webpackJsonp([1],Array(87).concat([
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(617)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(618)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Qiot使用说明.2e0304a.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/必加锁使用说明.5a0542c.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/物联网链接器.103f23b.png";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/闪钥使用说明.c56de02.png";

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Index__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_404__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Solution__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Solution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Solution__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Product__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Casus__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Casus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Casus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Support__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Support___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Support__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_About__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_About__);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		component: __WEBPACK_IMPORTED_MODULE_3__components_Index___default.a,
		children: [{
			path: '/',
			name: "Home",
			component: __WEBPACK_IMPORTED_MODULE_5__components_Home___default.a
		}, {
			path: '/solution',
			component: __WEBPACK_IMPORTED_MODULE_6__components_Solution___default.a
		}, {
			path: '/product',
			component: __WEBPACK_IMPORTED_MODULE_7__components_Product___default.a
		}, {
			path: '/product/:index',
			component: __WEBPACK_IMPORTED_MODULE_7__components_Product___default.a
		}, {
			path: '/casus',
			component: __WEBPACK_IMPORTED_MODULE_8__components_Casus___default.a
		}, {
			path: '/support',
			component: __WEBPACK_IMPORTED_MODULE_9__components_Support___default.a
		}, {
			path: '/support/:index',
			component: __WEBPACK_IMPORTED_MODULE_9__components_Support___default.a
		}, {
			path: '/about',
			component: __WEBPACK_IMPORTED_MODULE_10__components_About___default.a
		}, {
			path: '/about/:index',
			component: __WEBPACK_IMPORTED_MODULE_10__components_About___default.a
		}]
	}, {
		path: '/404',
		name: '404',
		component: __WEBPACK_IMPORTED_MODULE_4__components_404___default.a
	}]
}));

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	computed: {},

	props: {},

	methods: {},

	components: {},
	created: function created() {},
	mounted: function mounted() {},

	watch: {}
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_tabs_menu_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_tabs_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_tabs_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_footer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'about',
	data: function data() {
		var aArticle = null;
		var imgHead = null;
		if (this.$route.path.indexOf("_") < 0) {
			aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[this.$route.path].content;
			imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[this.$route.path].imgHead;
		} else {
			aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].content;
			imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].imgHead;
		}
		return {
			imgHead: imgHead,
			aArticle: aArticle
		};
	},

	computed: {
		aNavMenu: function aNavMenu() {
			return __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu;
		},
		imgNavPic: function imgNavPic() {
			return __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.imgNavPic;
		}
	},

	props: {},

	methods: {},

	components: {
		navMenu: __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue___default.a,
		tabsMenu: __WEBPACK_IMPORTED_MODULE_1__modules_tabs_menu_vue___default.a,
		foot: __WEBPACK_IMPORTED_MODULE_2__modules_footer___default.a
	},
	created: function created() {},
	mounted: function mounted() {},

	watch: {
		"$route.path": function $routePath(newV) {
			if (newV.indexOf("_") < 0) {
				this.aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[newV].content;
				this.imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[newV].imgHead;
			} else {
				this.aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[newV.split("_")[0]].child[newV].content;
				this.imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_about_article_js___default.a.aNavMenu[newV.split("_")[0]].child[newV].imgHead;
			}
		}
	}
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_home_page_6_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_home_page_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_home_page_6_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'casus',
	data: function data() {
		return {
			img: {
				bgCard_1: __webpack_require__(682),
				bgCard_2: __webpack_require__(683)
			},
			t1: null,
			"iPointIndex": 1,
			"aPointImgList": [__webpack_require__(686), __webpack_require__(687), __webpack_require__(688)],
			aList: [{
				name: "太阳能充电桩",
				img: __webpack_require__(666)
			}, {
				name: "市电路灯",
				img: __webpack_require__(670)
			}, {
				name: "室内智能灯",
				img: __webpack_require__(671)
			}, {
				name: "太阳能路灯",
				img: __webpack_require__(672)
			}, {
				name: "智能插座",
				img: __webpack_require__(673)
			}, {
				name: "净水器",
				img: __webpack_require__(674)
			}, {
				name: "空气净化器",
				img: __webpack_require__(675)
			}, {
				name: "空调",
				img: __webpack_require__(676)
			}, {
				name: "心电测量仪",
				img: __webpack_require__(677)
			}, {
				name: "智能门禁",
				img: __webpack_require__(667)
			}, {
				name: "按摩披肩",
				img: __webpack_require__(668)
			}, {
				name: "智能SPA沐浴",
				img: __webpack_require__(669)
			}],
			aCard: [{
				name: "建霖工业",
				desc: "利用了Qiot公版定制开发，降低了成本。",
				img: __webpack_require__(678)
			}, {
				name: "冠宇科技",
				desc: "基于Qiot云平台定制开发，使系统的性能提升了200%",
				img: __webpack_require__(679)
			}, {
				name: "曙创科技",
				desc: "基于Qiot云平台定制开发，降低了成本。",
				img: __webpack_require__(680)
			}, {
				name: "可锐卓",
				desc: "利用Qiot快速完成产品的更新和功能扩展，节省时间。",
				img: __webpack_require__(681)
			}]
		};
	},

	computed: {},

	props: {},

	methods: {
		fnInterval: function fnInterval() {
			if (this.t1 != null) {
				window.clearInterval(this.t1);
			}
			var _this = this;
			this.t1 = setInterval(function () {
				_this.iPointIndex = _this.iPointIndex + 1 > _this.aPointImgList.length ? 1 : _this.iPointIndex + 1;
			}, 3000);
		},
		fnPointClick: function fnPointClick(index) {
			this.iPointIndex = index;
			this.fnInterval();
		}
	},

	components: {
		foot: __WEBPACK_IMPORTED_MODULE_0__modules_home_page_6_vue___default.a
	},
	created: function created() {},
	mounted: function mounted() {
		this.fnInterval();
	},

	watch: {}
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'hello',
	data: function data() {
		return {
			msg: 'Welcome to Your Vue.js App'
		};
	},

	computed: {},

	props: {},

	methods: {},

	components: {},
	created: function created() {},
	mounted: function mounted() {},

	watch: {}
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_home_page_1_vue__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_home_page_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_home_page_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_home_page_2_vue__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_home_page_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_home_page_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_home_page_3_vue__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_home_page_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_home_page_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_home_page_4_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_home_page_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_home_page_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_home_page_5_vue__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_home_page_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_home_page_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_home_page_6_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_home_page_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_home_page_6_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'home',
	data: function data() {
		return {};
	},

	computed: {},

	props: {},

	methods: {
		fnScroll: function fnScroll(e) {
			var $this = this;
			if ($this.$store.state.oHomePage.oFirstFire === null) {
				e = e || window.event;
				var t = null;
				if (e.wheelDelta) {
					t = e.wheelDelta < 0;
				} else if (e.detail) {
					t = e.detail > 0;
				}
				if (t > 0) {
					$this.$store.commit("homeNext");
				} else {
					$this.$store.commit("homeBefore");
				}
			}
		}
	},

	components: {
		page_1: __WEBPACK_IMPORTED_MODULE_0__modules_home_page_1_vue___default.a,
		page_2: __WEBPACK_IMPORTED_MODULE_1__modules_home_page_2_vue___default.a,
		page_3: __WEBPACK_IMPORTED_MODULE_2__modules_home_page_3_vue___default.a,
		page_4: __WEBPACK_IMPORTED_MODULE_3__modules_home_page_4_vue___default.a,
		page_5: __WEBPACK_IMPORTED_MODULE_4__modules_home_page_5_vue___default.a,
		page_6: __WEBPACK_IMPORTED_MODULE_5__modules_home_page_6_vue___default.a
	},
	created: function created() {},
	mounted: function mounted() {
		window.onmousewheel = document.onmousewheel = this.fnScroll;
		if (document.attachEvent) {
			document.attachEvent('onmousewheel', this.fnScroll);
		} else if (document.addEventListener) {
			document.addEventListener('DOMMouseScroll', this.fnScroll, false);
		}
	},

	watch: {}
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: "index",
	data: function data() {
		return {
			"img": {
				"logo": __webpack_require__(726)
			}
		};
	},

	computed: {
		sMenuSelected: function sMenuSelected() {
			var s = this.$route.path.split("/")[1];
			s = s == "" ? "home" : s;
			return this.$store.state.aIndexMenu[s].path;
		}
	},
	methods: {
		"fnMenu": function fnMenu(tab, event) {
			this.fnToRouter(tab.name);
		}
	},
	components: {},
	created: function created() {},

	watch: {},
	mounted: function mounted() {}
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_footer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'product',
	data: function data() {
		var aArticle = null;
		var imgHead = null;
		if (this.$route.path.indexOf("_") < 0) {
			aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[this.$route.path].content;
			imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[this.$route.path].imgHead;
		} else {
			aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].content;
			imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].imgHead;
		}
		return {
			aArticle: aArticle,
			imgHead: imgHead
		};
	},

	computed: {
		aNavMenu: function aNavMenu() {
			return __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu;
		},
		imgNavPic: function imgNavPic() {
			return __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.imgNavPic;
		}
	},

	props: {},

	methods: {},

	components: {
		navMenu: __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue___default.a,
		foot: __WEBPACK_IMPORTED_MODULE_1__modules_footer___default.a,
		tabsMenu: __WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue___default.a
	},
	created: function created() {},
	mounted: function mounted() {},

	watch: {
		"$route.path": function $routePath(newV) {
			if (newV.indexOf("_") < 0) {
				this.aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[newV].content;
				this.imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[newV].imgHead;
			} else {
				this.aArticle = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[newV.split("_")[0]].child[newV].content;
				this.imgHead = __WEBPACK_IMPORTED_MODULE_3__assets_data_product_article_js___default.a.aNavMenu[newV.split("_")[0]].child[newV].imgHead;
			}
		}
	}
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_solution_tab_1_vue__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_solution_tab_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_solution_tab_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_solution_tab_2_vue__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_solution_tab_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_solution_tab_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_solution_tab_3_vue__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_solution_tab_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_solution_tab_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_home_page_6_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_home_page_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_home_page_6_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'solution',
	data: function data() {
		return {
			"img": {
				headBg: __webpack_require__(747)
			},
			"tab_active": "2_1",
			"isFixed": false,
			"y": {
				"scroll": 0,
				"tabs": 0,
				"tab": [],
				"foot": 0
			}
		};
	},

	computed: {},

	props: {},

	methods: {
		bodyScroll: function bodyScroll() {
			this.y.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			this.isFixed = this.y.scroll >= this.y.tabs;
			if (this.y.scroll > this.y.foot - 60) {
				this.isFixed = false;
			}
			if (this.y.scroll >= this.y.tab["2_1"]) {
				this.tab_active = "2_1";
			}
			if (this.y.scroll >= this.y.tab["2_2"]) {
				this.tab_active = "2_2";
			}
			if (this.y.scroll >= this.y.tab["2_3"]) {
				this.tab_active = "2_3";
			}
		},
		tabClick: function tabClick(i, o) {
			console.log(i.name);
			console.log(this.y.tab[i.name]);
			window.scrollTo(0, this.y.tab[i.name]);
		}
	},

	components: {
		tab_1: __WEBPACK_IMPORTED_MODULE_0__modules_solution_tab_1_vue___default.a,
		tab_2: __WEBPACK_IMPORTED_MODULE_1__modules_solution_tab_2_vue___default.a,
		tab_3: __WEBPACK_IMPORTED_MODULE_2__modules_solution_tab_3_vue___default.a,
		foot: __WEBPACK_IMPORTED_MODULE_3__modules_home_page_6_vue___default.a
	},
	created: function created() {},
	mounted: function mounted() {
		this.y.tabs = document.getElementsByClassName("tabs")[0].offsetTop;
		this.y.tab["2_1"] = document.getElementsByClassName("tab1")[0].offsetTop - 100;
		this.y.tab["2_2"] = document.getElementsByClassName("tab2")[0].offsetTop - 100;
		this.y.tab["2_3"] = document.getElementsByClassName("tab3")[0].offsetTop - 100;
		this.y.foot = document.getElementsByClassName("page_6")[0].offsetTop;
		if (window.attachEvent) {
			window.attachEvent('onscroll', this.bodyScroll);
		} else if (document.addEventListener) {
			document.addEventListener('scroll', this.bodyScroll, false);
		}
	},

	watch: {}
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_footer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_lists_menu_vue__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_lists_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_lists_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'support',
	data: function data() {
		var aArticle = null;
		var imgHead = null;
		if (this.$route.path.indexOf("_") < 0) {
			aArticle = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[this.$route.path].content;
			imgHead = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[this.$route.path].imgHead;
		} else {
			aArticle = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].content;
			imgHead = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].imgHead;
		}
		return {
			aArticle: aArticle,
			imgHead: imgHead
		};
	},

	computed: {
		aNavMenu: function aNavMenu() {
			return __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu;
		},
		imgNavPic: function imgNavPic() {
			return __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.imgNavPic;
		},
		isList: function isList() {
			var a = this.$route.path;

			if (a.indexOf("_") < 0) {
				return __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[this.$route.path].isList;
			} else {
				return __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].isList;
			}
		}
	},

	props: {},

	methods: {},

	components: {
		navMenu: __WEBPACK_IMPORTED_MODULE_0__modules_nav_menu_vue___default.a,
		foot: __WEBPACK_IMPORTED_MODULE_1__modules_footer___default.a,
		tabsMenu: __WEBPACK_IMPORTED_MODULE_2__modules_tabs_menu_vue___default.a,
		listsMenu: __WEBPACK_IMPORTED_MODULE_3__modules_lists_menu_vue___default.a
	},
	created: function created() {},
	mounted: function mounted() {},

	watch: {
		"$route.path": function $routePath(newV) {
			if (newV.indexOf("_") < 0) {
				this.aArticle = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[newV].content;
				this.imgHead = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[newV].imgHead;
			} else {
				this.aArticle = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[newV.split("_")[0]].child[newV].content;
				this.imgHead = __WEBPACK_IMPORTED_MODULE_4__assets_data_support_article_js___default.a.aNavMenu[newV.split("_")[0]].child[newV].imgHead;
			}
		}
	}
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			"about": [{
				"icon": "icon-111"
			}, {
				"icon": "icon-weixin"
			}, {
				"icon": "icon-xinlang"
			}, {
				"icon": "icon-taobao",
				"url": "https://qlinkcc.taobao.com/?qq-pf-to=pcqq.c2c"
			}]
		};
	},

	computed: {},
	props: {},
	methods: {
		toTop: function toTop() {
			if (this.$route.path == "/") {
				this.$store.state.oHomePage.index = 1;
			} else {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
				if (scrollTop > 0) {
					var t1 = window.setInterval(function () {
						if (scrollTop > 100) {
							scrollTo(0, scrollTop /= 1.3);
						} else {
							scrollTo(0, 0);
							window.clearInterval(t1);
						}
					}, 20);
				}
			}
		},
		topage: function topage(url) {
			this.fnToRouter(url);
		},
		toWan: function toWan(url) {
			window.location.href = url;
		}
	},
	components: {},
	created: function created() {},
	mounted: function mounted() {}
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			mapStyle: {
				width: '100%',
				height: this.mapHeight
			},
			mapImg: __webpack_require__(721),
			company: "厦门酷联客电子科技有限公司",
			address: "厦门市湖里区园山南路806号联发电子市场B栋804号",
			tel: "(0592)8222272",
			desc: "厦门酷联客电子科技有限公司（简称“酷联客”）是一家物联网（IOT）开放式接入服务云平台的公司，面向产业提供联网服务，并以此为核心展开一系列增值服务运营。"
		};
	},
	props: {
		mapHeight: {
			type: String,
			default: "70vh"
		},

		longitude: {
			type: Number,
			default: 118.13752
		},

		latitude: {
			type: Number,
			default: 24.511568
		},

		precision: {
			type: Number,
			default: 17
		}
	},
	mounted: function mounted() {
		var map = new BMap.Map("allmap");
		map.centerAndZoom(new BMap.Point(this.longitude, this.latitude), this.precision);

		var top_left_control = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_TOP_LEFT });
		var top_left_navigation = new BMap.NavigationControl();

		map.addControl(top_left_control);
		map.addControl(top_left_navigation);

		var content = '';
		content += '<div style="margin:0;line-height:20px;padding:2px;">';
		content += '	<img src="' + this.mapImg + '" alt="" style="float:right;zoom:1;overflow:hidden;width:140px;height:140px;margin-left:3px;"/>';
		content += '	地址：' + this.address + '<br/>';
		content += '	电话：' + this.tel + '<br/>';
		content += '	简介：' + this.desc;
		content += '</div>';
		var $this = this;

		var searchInfoWindow = null;
		searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
			title: $this.company,
			width: 420,
			height: 150,
			panel: "panel",
			enableAutoPan: true,
			searchTypes: [BMAPLIB_TAB_SEARCH, BMAPLIB_TAB_TO_HERE, BMAPLIB_TAB_FROM_HERE]
		});

		var poi = new BMap.Point(this.longitude, this.latitude);
		var marker = new BMap.Marker(poi);
		marker.enableDragging();
		map.addOverlay(marker);
		searchInfoWindow.open(marker);
		marker.addEventListener("click", function (e) {
			searchInfoWindow.open(marker);
		});
	}
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			img: {
				material: __webpack_require__(717),
				next: __webpack_require__(725)
			}
		};
	},

	computed: {},
	methods: {},
	components: {},
	created: function created() {}
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			iCardIndex: 0,
			img: {
				jiantou: __webpack_require__(720)
			},
			aCardGroup: [{
				"name": "公云通用版",
				"img": __webpack_require__(689),
				"img_hover": __webpack_require__(690),
				"desc": "无需顾虑成本、开发速度、开发沟通等因素，Qiot免费使用，上手即可实现：定义协议生成控制通讯APP"
			}, {
				"name": "公云UI制定版",
				"img": __webpack_require__(691),
				"img_hover": __webpack_require__(692),
				"desc": "无需开发，只需要UI设计师，即可完成个性化定制。基于通用版为您制定产品专属页面。"
			}, {
				"name": "公云品牌制定版",
				"img": __webpack_require__(693),
				"img_hover": __webpack_require__(694),
				"desc": "品牌专属APP在这里无需开发，基于Qiot定制成您的品牌专属APP，拥有个性化UI界面。"
			}, {
				"name": "私云运营级版",
				"img": __webpack_require__(695),
				"img_hover": __webpack_require__(696),
				"desc": "与公云服务器功能一致，含手机端Qiot通用版及PC端管理后台所有功能。私云独立运作，独立数据存储。"
			}]
		};
	},

	computed: {
		"sDesc": function sDesc() {
			return this.aCardGroup[this.iCardIndex];
		}
	},
	methods: {
		"fnImageHover": function fnImageHover(item, i) {
			var temp = item.img;
			item.img = item.img_hover;
			item.img_hover = temp;
			this.iCardIndex = i;
		}
	},
	components: {},
	created: function created() {}
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			cardList: [{
				"name": "物联网连接模块",
				"desc": "基于QLINK物联网模块，提供RS232、RS485、TTL、继电器接口，适用于任何微控制器、任何操作系统以及任何联网协议，开发者可将其应用于产品中，直接连接到QLINK云服务器。",
				"btn": { name: "QLINK物联网模块", url: "" },
				"img": __webpack_require__(697),
				"img_hover": __webpack_require__(698)
			}, {
				"name": "Qlink物联网服务器",
				"desc": "传统企业快速接入，轻松对接其他系统平台，安全稳定。提供完善的管理能力、商业智能以及大数据分析服务，用于管理海量的联网产品，云端全球化部署，远程控制、管理用户和管理设备。",
				"btn": { name: "QLINK云服务器", url: "" },
				"img": __webpack_require__(699),
				"img_hover": __webpack_require__(700)
			}, {
				"name": "物联网免开发软件",
				"desc": "QLINK的移动应用开发库包含丰富的API及丰富的设备UI模版，无需开发iOS和Android应用，自由选择也可个性制定应用来控制和管理基于QLINK的智能产品。",
				"btn": { name: "Qiot Pro APP", url: "" },
				"img": __webpack_require__(701),
				"img_hover": __webpack_require__(702)
			}]
		};
	},

	computed: {},
	methods: {
		update: function update(item) {
			var temp = item.img;
			item.img = item.img_hover;
			item.img_hover = temp;
		}
	},
	components: {},
	created: function created() {}
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			cardList: [{
				"name": "物联网连接服务",
				"desc": "稳定灵活适应业务需求",
				"img": __webpack_require__(703),
				"img_hover": __webpack_require__(704)
			}, {
				"name": "云服务器",
				"desc": "三高特性云服务器",
				"img": __webpack_require__(705),
				"img_hover": __webpack_require__(706)
			}, {
				"name": "大数据分析",
				"desc": "大规模并行处理数据",
				"img": __webpack_require__(707),
				"img_hover": __webpack_require__(708)
			}, {
				"name": "APP制定开发",
				"desc": "为电器智能控制项目加速",
				"img": __webpack_require__(709),
				"img_hover": __webpack_require__(710)
			}]
		};
	},

	computed: {},
	methods: {
		update: function update(item) {
			var temp = item.img;
			item.img = item.img_hover;
			item.img_hover = temp;
		}
	},
	components: {},
	created: function created() {}
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			"list": [{
				"name": "智能控制",
				"desc": "提供多款主流设备模版页面，可自定义控制任意设备",
				"img": __webpack_require__(711),
				"img_hover": __webpack_require__(712)
			}, {
				"name": "场景控制",
				"desc": "自定义条件出发多设备控制命令转化成一键或自动化控制",
				"img": __webpack_require__(713),
				"img_hover": __webpack_require__(714)
			}, {
				"name": "调试控制",
				"desc": "创建开发板设备，自定义开关控制或数据显示的控件",
				"img": __webpack_require__(715),
				"img_hover": __webpack_require__(716)
			}]
		};
	},

	computed: {},
	methods: {
		update: function update(item) {
			var temp = item.img;
			item.img = item.img_hover;
			item.img_hover = temp;
		}
	},
	components: {},
	created: function created() {}
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_footer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_home_bmap_vue__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_home_bmap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_home_bmap_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'page_6',
	data: function data() {
		return {
			imgBg: __webpack_require__(723),
			"dialogInfo": false,
			"dialogMap": false,
			"formData": {
				name: "",
				phone: "",
				company: "",
				demand: ""
			},

			formRules: {
				name: [{
					trigger: 'blur',
					required: true,
					message: "请输入姓名"
				}],
				phone: [{
					trigger: 'blur',
					required: true,
					message: "请输入手机号"
				}, {
					trigger: 'blur,change',
					validator: function validator(rule, value, callback) {
						if (!/^1[34578]\d{9}$/.test(value)) {
							return callback("请输入正确的手机号");
						} else {
							return callback();
						}
					}
				}],
				company: [{
					trigger: 'blur',
					required: true,
					message: "请输入公司名称"
				}],
				demand: [{
					trigger: 'blur',
					required: true,
					message: "请输入需求"
				}]
			}
		};
	},

	computed: {},

	props: {},

	methods: {
		fnScroll: function fnScroll() {
			if (this.dialogInfo) {
				this.dialogInfo = false;
			}
			if (this.dialogMap) {
				this.dialogMap = false;
			}
		}
	},

	components: {
		foot: __WEBPACK_IMPORTED_MODULE_0__modules_footer___default.a,
		BMap: __WEBPACK_IMPORTED_MODULE_1__modules_home_bmap_vue___default.a
	},
	created: function created() {},
	mounted: function mounted() {
		window.onmousewheel = document.onmousewheel = this.fnScroll;
		if (document.attachEvent) {
			document.attachEvent('onmousewheel', this.fnScroll);
		} else if (document.addEventListener) {
			document.addEventListener('DOMMouseScroll', this.fnScroll, false);
		}
	},

	watch: {}
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'lists-menu',
	data: function data() {
		return {
			isFixed: false,
			list_active: "0-0",
			y: {
				scroll: 0,
				list: 0,
				article_title: []
			}
		};
	},

	computed: {},

	props: {
		"menu": null
	},

	methods: {
		fnScroll: function fnScroll() {
			this.y.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		}
	},

	components: {},
	created: function created() {},
	mounted: function mounted() {
		this.y.list = document.getElementsByClassName("article")[0].offsetTop + 100;
		var article_title_sub_list = document.getElementsByClassName("article_title_sub");
		for (var i = 0; i < article_title_sub_list.length; i++) {
			var height = article_title_sub_list[i].offsetTop + this.y.list - 80;
			var index = article_title_sub_list[i].getAttribute("index");

			var a = new Object();
			a.height = height;
			a.index = index;
			this.y.article_title.push(a);
		}

		if (window.attachEvent) {
			window.attachEvent('onscroll', this.fnScroll);
		} else if (document.addEventListener) {
			document.addEventListener('scroll', this.fnScroll, false);
		}
	},

	watch: {
		"y.scroll": function yScroll(newY) {
			if (newY >= this.y.list) {
				this.isFixed = true;
			} else {
				this.isFixed = false;
			}
			for (var i = 0; i < this.y.article_title.length; i++) {
				if (newY > this.y.article_title[i].height) {
					this.list_active = this.y.article_title[i].index;
				}
			}
		}
	}
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'nav',
	data: function data() {
		return {};
	},

	computed: {
		defaultSelect: function defaultSelect() {
			return this.$route.path;
		}
	},

	props: {
		bgNav: {},
		menu: {}
	},

	methods: {},

	components: {},
	created: function created() {},
	mounted: function mounted() {},

	watch: {}
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tab_1',
	data: function data() {
		return {
			cardList: [{
				"name": "净水器",
				"desc": "实时监测水质，用水健康提醒",
				"img": __webpack_require__(728),
				"img_hover": __webpack_require__(729)
			}, {
				"name": "农业灌溉",
				"desc": "实时监测数据，智能灌溉",
				"img": __webpack_require__(730),
				"img_hover": __webpack_require__(731)
			}, {
				"name": "智能家居",
				"desc": "一个应用控制部署所有家电",
				"img": __webpack_require__(732),
				"img_hover": __webpack_require__(733)
			}, {
				"name": "工业采集控制",
				"desc": "远程监测实时采集数据及控制",
				"img": __webpack_require__(734),
				"img_hover": __webpack_require__(735)
			}]
		};
	},

	computed: {},

	props: {},

	methods: {
		update: function update(item) {
			var temp = item.img;
			item.img = item.img_hover;
			item.img_hover = temp;
		}
	},

	components: {},
	created: function created() {},
	mounted: function mounted() {},

	watch: {}
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tab_2',
	data: function data() {
		return {
			"sAction": "1",
			list: {
				"tab2_1": {
					"pic": __webpack_require__(742),
					"title_sub": "私有云解决方案",
					"sub_des": "可适用于物联网私有云",
					"btn": {
						"name": "了解更多",
						"url": "/404"
					},
					"product": [{ "name": "服务器主机", "url": "/404" }, { "name": "Qiot软件", "url": "/404" }, { "name": "Web管理后台", "url": "/404" }],
					content: [{
						"h": "软硬SDN",
						"p": "支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。"
					}, {
						"h": "自动化部署",
						"p": "在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。"
					}, {
						"h": "统一管理",
						"p": "不仅在PC端，手机端也能管理，简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。"
					}, {
						"h": "多层安全防护",
						"p": "通过密钥登陆，虚拟防火墙，安全管理等方式，达到防APP、IP欺骗、ART攻击、放DDOS攻击的效果，并确保使用过程安全稳定。"
					}]
				},
				"tab2_2": {
					"pic": __webpack_require__(743),
					"title_sub": "智能设备解决方案",
					"sub_des": "可适用于所有白电设备，净水器、空气净化器、热水器、电饭煲、风扇、空调……",
					"btn": {
						"name": "了解更多",
						"url": "/404"
					},
					"product": [{ "name": "物联网模块", "url": "/404" }, { "name": "Qiot软件", "url": "/404" }, { "name": "Web管理后台", "url": "/404" }],
					content: [{
						"h": "功能连接模块化",
						"p": "灵活连接，支持多种波特率，可自行连接传感模块、GPS定位模块等功能模块，更方便更兼容地应用于产品中，利用经过验证的成熟技术加速智能产品的上市时间。"
					}, {
						"h": "多种协议轻松通讯",
						"p": "支持多种通信协议，能够更好地适配不同种类的产品。轻量级定制开发，根据设备的协议直接生成控制UI，无需开发。"
					}, {
						"h": "大数据",
						"p": "数据统计，能够提供消费者使用习惯和消费者健康信息的大数据分析。"
					}, {
						"h": "远程控制管理",
						"p": "配套手机端控制软件Qiot APP及Web端管理后台，可随时随地的控制和管理。企业用户可通过手机端或PC端来管理用户及产品。"
					}]
				},
				"tab2_3": {
					"pic": __webpack_require__(744),
					"title_sub": "智能家居解决方案",
					"sub_des": "可适用于智慧城市、智能教室、智能办公",
					"btn": {
						"name": "了解更多",
						"url": "/404"
					},
					"product": [{ "name": "物联网链接器", "url": "/404" }, { "name": "Qiot软件", "url": "/404" }, { "name": "Web管理后台", "url": "/404" }],
					content: [{
						"h": "超低门槛，极简操作",
						"p": "厂商无需购买服务器等软硬件设备，也无需经过漫长的实施周期，只需注册一个帐号即可使用。厂商无须任何的前期投入，节省了大量的软硬件采购成本，同时大幅缩短项目的上线周期。您既可以省去购买服务器等软硬件设施的费用，也没有系统维护成本。在使用过程中，也没有设备折旧、软件升级、维护人工、服务器电费等隐形成本。"
					}, {
						"h": "互联网+",
						"p": "接入方式灵活多变，通过任意一台电脑、智能手机、平板电脑等都可以方便地访问系统。无论您是出差在宾馆，还是出游的旅途中，都可以通过互联网或手机无线网络访问系统，管理您的客户数据。"
					}, {
						"h": "系统维护",
						"p": "所有的系统维护，升级等工作均由QLINK物联云在后台完成，无需用户干预。用户只需注册一个帐号即可使用，省去了系统维护，升级等麻烦，系统使用省心省力。"
					}]
				},
				"tab2_4": {
					"pic": __webpack_require__(745),
					"title_sub": "农业灌溉解决方案",
					"sub_des": "可适用于农业大棚、农田灌溉",
					"btn": {
						"name": "了解更多",
						"url": "/404"
					},
					"product": [{ "name": "GPRS智能网关", "url": "/404" }, { "name": "Qiot软件", "url": "/404" }, { "name": "Web管理后台", "url": "/404" }],
					content: [{
						"h": "集木式构建",
						"p": "采用无线扩展的开放式思路，采用先进的集木式构建。整个灌溉系统由多组集群控制单元组成，并且灌溉系统容量越大，平均投资成本就越低，生产效率就越高。"
					}, {
						"h": "功能模块化",
						"p": "本系统由多组集群控制单元组成，每组集群控制单元功能模块化、层次化设计，以提高效率，增加可维护性，便于扩展。"
					}, {
						"h": "大数据",
						"p": "通过多种传感器采集土壤温度、湿度，空气温度、湿度，光照强度等数据，并且可分析灌溉时某段时间的用水量、总用水量、平均用水量等数据，智能提醒灌溉，分析灌溉水量，科学节约用水。"
					}, {
						"h": "统一远程控制管理",
						"p": "配套手机端控制软件Qiot APP及Web端管理后台，可随时随地的控制和管理，安全可靠。硬件更换无需更换软件，一个软件即可管理控制所有灌溉系统的被控硬件设备。"
					}]
				},
				"tab2_5": {
					"pic": __webpack_require__(746),
					"title_sub": "工业采集解决方案",
					"sub_des": "可适用于智能制造、监控监测……",
					"btn": {
						"name": "了解更多",
						"url": "/404"
					},
					"product": [{ "name": "物联网链接器", "url": "/404" }, { "name": "Qiot软件", "url": "/404" }, { "name": "Web管理后台", "url": "/404" }],
					content: [{
						"h": "手机端采集",
						"p": "突破传统PC采集的方法，以手机端APP简捷操作来采集并控制硬件，手机端智能Qiot控制软件可对任何硬件设备进行数据采集、远程控制、场景控制、定时控制。"
					}, {
						"h": "简化流程",
						"p": "本方案是通过链接器经过网络直接传送数据至服务器，用手机端来显示数据和控制硬件，其中物联网链接器的接口丰富，含有RS232、RS485、TTL、继电器的接口，硬件只需接入链接器即可，链接器接入可出外网的以太网络，远程传输数据至云服务器，省去了设备端与采集器的开发与设置，直接连接后使用手机端Qiot软件即可轻松实现远程采集数据。"
					}, {
						"h": "远程采集",
						"p": "本方案的目的是以极简的架构实现远程手机端采集数据及监控，由智能的物联网链接器与Qiot软件组合使用。链接器接入可出外网的以太网络，远程传输数据至云服务器，然后使用手机端Qiot软件远程采集数据及控制设备。"
					}]
				}

			}
		};
	},

	computed: {
		content: function content() {
			return this.list['tab2_' + this.sAction];
		}
	},

	props: {},

	methods: {
		fnSelect: function fnSelect(index) {
			this.sAction = index;
		}
	},

	components: {},
	created: function created() {},
	mounted: function mounted() {},

	watch: {}
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tab_3',
	data: function data() {
		return {
			cardList: [{
				"img": __webpack_require__(738),
				"img_hover": __webpack_require__(739)
			}, {
				"name": "农业灌溉",
				"desc": "实时监测数据，智能灌溉",
				"img": __webpack_require__(736),
				"img_hover": __webpack_require__(737)
			}, {
				"name": "智能家居",
				"desc": "一个应用控制部署所有家电",
				"img": __webpack_require__(740),
				"img_hover": __webpack_require__(741)
			}, {
				"name": "工业采集控制",
				"desc": "远程监测实时采集数据及控制",
				"img": __webpack_require__(748),
				"img_hover": __webpack_require__(749)
			}]
		};
	},

	computed: {},

	props: {},

	methods: {
		update: function update(item) {
			var temp = item.img;
			item.img = item.img_hover;
			item.img_hover = temp;
		}
	},

	components: {},
	created: function created() {},
	mounted: function mounted() {},

	watch: {}
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tabs-menu',
	data: function data() {
		return {
			isFixed: false,
			tab_active: this.menu[0].name,
			y: {
				scroll: 0,
				tabs: 0,
				title: []
			}
		};
	},

	computed: {},

	props: {
		"menu": {},
		"width": {}
	},

	methods: {
		fnScroll: function fnScroll() {
			this.y.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		},
		tabClick: function tabClick(i, o) {
			window.scrollTo(0, this.y.title[i.index] + 140);
		}
	},

	components: {},
	created: function created() {},
	mounted: function mounted() {
		this.y.tabs = document.getElementsByClassName("article_tab")[0].offsetTop + 95;
		this.y.title = new Array();
		var title_list = document.getElementsByClassName("article_title");
		for (var i = 0; i < title_list.length; i++) {
			this.y.title.push(title_list[i].offsetTop - 80);
		}

		if (window.attachEvent) {
			window.attachEvent('onscroll', this.fnScroll);
		} else if (document.addEventListener) {
			document.addEventListener('scroll', this.fnScroll, false);
		}
	},

	watch: {
		menu: function menu(newV) {
			this.tab_active = newV[0].name;
			this.$nextTick(function () {
				this.y.title = new Array();
				var title_list = document.getElementsByClassName("article_title");
				for (var i = 0; i < title_list.length; i++) {
					this.y.title.push(title_list[i].offsetTop - 80);
				}
			});
		},
		"y.scroll": function yScroll(newV) {
			this.isFixed = newV >= this.y.tabs;
			for (var i = 0; i < this.y.title.length; i++) {
				if (newV > this.y.title[i]) {
					this.tab_active = this.menu[i].name;
				}
			}
		}
	}
});

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
	"imgNavPic": __webpack_require__(634),
	"aNavMenu": {
		"/about": {
			"name": "公司简介",
			"imgHead": __webpack_require__(635),
			"content": [{
				"name": "公司介绍",
				"text": ["厦门酷联客电子科技有限公司（简称“酷联客”）创立于2014年1月，坐落于厦门市湖里区园山南路806号，是一家物联网（IOT）开放式接入服务云平台的公司，面向产业提供联网服务，并以此为核心展开一系列增值服务运营。", "酷联客硬件产品方面有物联网链接器、物联网嵌入式模块等。公司拥有强大的嵌入式软硬件研发团队, 手机程序开发以及服务器程序开发团队, 可为客户提供 OEM 和 ODM 服务。我们能提供从嵌入式硬件、嵌入式软件、上位机软件; 并提供私有云服务器, APP 开发等全方位的与联网控制相关的产品和服务，同时还提供私有云、互联网+、物联网联动、方便、易用、节能、可靠、高效的解决方案。"]
			}, {
				"name": "酷联客事迹",
				"text": ["☆   <b>2014年</b>", "1月，公司成立，专注智能家居领域；", "5月，开发智能家居全套硬件及软件，以平台化方案开发进行；", "☆   <b>2015年</b>", "1月，酷联客转型为物联网公司，物联网接入平台上线运营；", "10月，中国互联网协会会员单位；", "☆   <b>2016年</b>", "1月，酷联客构建的物联网链接服务完善；", "6月，荣获“物联中国”年度盛典“白鹭奖”最具投资价值物联网项目“百佳项目”；", "7月，Qiot物联网控制软件开发项目启动；", "10月，Qiot正式公测；", "10月，爱提醒物联网科技（漳州）有限公司成立；"]
			}, {
				"name": "团队",
				"text": ["<b>软硬件全栈工程师</b>：拥有20年以上开发管理经验，熟悉软硬件通讯开发流程，熟悉项目管理，完成多套软硬件系统，主要负责公司内部网络系统和应用系统的开发。", "<b>运营总监</b>：拥有12年IT&物联网行业经验，特别在运营服务领域有独到见解。对于云计算行业、智能家居以及海量用户的运营服务有着丰富的经验。", "<b>IOT核心工程师</b>：拥有10年以上开发管理经验,熟悉软硬件通讯开发流程及项目管理，完成多套软硬件系统；2003-2009年曾就职于夏新股份有限公司，负责公司内部网络系统和应用系统的开发。", "<b>Android工程师</b>：拥有6年IT&物联网行业的研发管理经验，2011年6月毕业于华侨大学信号与信息处理专业硕士；2011年8月-2013年8月在南京诚迈股份有限公司，主要负责Android手机端研发底层ROM并带领团队做第三方APP；2013年8月-2014年8月就职于厦门立林软件有限公司，主要负责带团队研究立林智能家居的研发。", "<b>iOS工程师</b>：拥有8年工作经验，曾在北京汽车之家担任项目经理，厦门网龙网络科技有限公司担任项目经理。", "<b>前端工程师</b>：拥有5年Web开发经验，擅长HTML、CSS、Web后端开发，独立完成10个项目。", "<b>设计师</b>：拥有6年大公司平面广告设计经验，擅长UI设计，平面广告设计，美工设计。完成30余个项目UI的完整设计。"]
			}]
		},
		"/about/2": {
			"name": "联系我们",
			"imgHead": __webpack_require__(649),
			"content": [{
				"name": "厦门",
				"text": ["厦门酷联客电子科技有限公司", "电话：0592-8222272", "地址：厦门市湖里区园山南路806号联发电子广场B座804室", "邮编：361006"]
			}, {
				"name": "漳州",
				"text": ["福建爱提醒物联网科技有限公司", "电话：0596-2096918", "手机：王总 13306069090", "地址：福建省漳州高新区九湖镇众创园2栋4层", "邮编：363000"]
			}]
		},
		"/about/3": {
			"name": "新闻动态",
			"child": {
				"/about/3_1": {
					"name": "最新动态",
					"icon": "iconfont icon-zuixindongtai",
					"imgHead": __webpack_require__(648),
					"content": [{
						"name": "近日动态",
						"text": ["暂无消息"]
					}]
				},
				"/about/3_2": {
					"name": "产品更新",
					"icon": "iconfont icon-chanpingengxin",
					"imgHead": __webpack_require__(647),
					"content": [{
						"name": "产品更新",
						"text": ["暂无消息"]
					}]
				}
			}
		},
		"/about/4": {
			"name": "加入我们",
			"child": {
				"/about/4_1": {
					"name": "社会招聘",
					"icon": "iconfont icon-shehuizhaopin",
					"imgHead": __webpack_require__(646),
					"content": [{
						"name": "社会招聘",
						"text": ["暂无消息"]
					}]
				},
				"/about/4_2": {
					"name": "校园招聘",
					"icon": "iconfont icon-xiaoyuanzhaopin",
					"imgHead": __webpack_require__(645),
					"content": [{
						"name": "校园招聘",
						"text": ["暂无消息"]
					}]
				}
			}
		},
		"/about/5": {
			"name": "物联网初创企业成长计划",
			"imgHead": __webpack_require__(636),
			"content": [{
				"name": "产品智能化流程",
				"text": [__webpack_require__(637), __webpack_require__(638), __webpack_require__(639)]
			}, {
				"name": "玩转产品智能化发展进阶攻略",
				"text": [__webpack_require__(640), __webpack_require__(641), __webpack_require__(642), __webpack_require__(643), __webpack_require__(644)]
			}]
		}
	}
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
	"imgNavPic": __webpack_require__(653),
	"aNavMenu": {
		"/product": {
			"name": "接入服务",
			"imgHead": __webpack_require__(652),
			"content": [{
				"name": "优势",
				"text": ["<b>软硬SDN</b>", "支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。", "<b>自动化部署</b>", "在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。", "<b>统一管理</b>", "使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。", "<b>多版本&二次开发</b>", "提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"]
			}, {
				"name": "应用",
				"text": ["<b>软硬SDN</b>", "支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。", "<b>自动化部署</b>", "在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。", "<b>统一管理</b>", "使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。", "<b>多版本&二次开发</b>", "提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"]
			}, {
				"name": "文档",
				"text": ["<b>软硬SDN</b>", "支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。", "<b>自动化部署</b>", "在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。", "<b>统一管理</b>", "使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。", "<b>多版本&二次开发</b>", "提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"]
			}, {
				"name": "案例",
				"text": ["<b>软硬SDN</b>", "支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。", "<b>自动化部署</b>", "在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。", "<b>统一管理</b>", "使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。", "<b>多版本&二次开发</b>", "提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"]
			}]
		},
		"/product/2": {
			"name": "云主机",
			"imgHead": __webpack_require__(654),
			"content": [{
				"name": "优势",
				"text": ["QM2D服务器 即quick link mobile to device；快速建立移动终端和设备的链接服务器。", "<b>标准功能：</b>", "*移动终端和设备连接的透明通道", "*设备和设备连接的透明通道", "*设备和设备连接的透明通道", "*设备管理功能", "*移动终端管理功能", "*实时数据展示功能。", "*设备实时状态监视功能。", "*APP使用权"]
			}, {
				"name": "配置",
				"text": ["暂无信息"]
			}, {
				"name": "实图",
				"text": ["暂无信息"]
			}, {
				"name": "应用",
				"text": ["暂无信息"]
			}, {
				"name": "文档",
				"text": ["暂无信息"]
			}, {
				"name": "案例",
				"text": ["暂无信息"]
			}]
		},
		"/product/3": {
			"name": "硬件产品",
			"child": {
				"/product/3_1": {
					"name": "物联网模块",
					"icon": "iconfont icon-wulianwangmokuai",
					"imgHead": __webpack_require__(657),
					"content": [{
						"name": "功能",
						"text": ["提供RS232、RS485、TTL、继电器接口，可直接与硬件对联，无需设置，双向反馈，实时透传数据。可连接传感模块、GPS定位模块，配合功能模块可实现自动化控制。"]
					}, {
						"name": "配置",
						"text": ["暂无信息"]
					}, {
						"name": "实图",
						"text": ["暂无信息"]
					}, {
						"name": "应用",
						"text": ["暂无信息"]
					}, {
						"name": "文档",
						"text": ["暂无信息"]
					}, {
						"name": "案例",
						"text": ["暂无信息"]
					}]
				},
				"/product/3_2": {
					"name": "物联网链接器",
					"icon": "iconfont icon-wulianwanglianjieqi",
					"imgHead": __webpack_require__(658),
					"content": [{
						"name": "功能",
						"text": ["简易操作，简约设计，插上电源接入网络即完成安装，客户可根据设备类型及数据类型自主选择相应配置来连接设备。物联网链接器为数据传输提供4800、9600、38400、115200四种波特率，为设备连接提供了RS232、RS485、TTL、继电器接口，可直接与设备连接，无需设置，双向反馈，实时透传数据。"]
					}, {
						"name": "配置",
						"text": ["暂无信息"]
					}, {
						"name": "实图",
						"text": ["暂无信息"]
					}, {
						"name": "应用",
						"text": ["暂无信息"]
					}, {
						"name": "文档",
						"text": ["暂无信息"]
					}, {
						"name": "案例",
						"text": ["暂无信息"]
					}]
				}
			}
		},
		"/product/4": {
			"name": "软件产品",
			"child": {
				"/product/4_1": {
					"name": "Qiot Pro",
					"icon": "iconfont icon-QiotPro",
					"imgHead": __webpack_require__(651),
					"content": [{
						"name": "功能",
						"text": ["二维码扫描轻松添加设备，多种添加方式，多种设备类型可选，可自定义设备控制UI。智能控制、场景控制、定时控制是Qiot的三大主要功能，用户可以使用Qiot对设备进行远程智能控制，可以将多个控制命令任意组合成一键场景控制，可以对设备的某个控制命令或场景进行定时执行。还可对正在开发或已完成开发的设备进行调试，通过设备发来的报文，将报文直接转化为控制控件（控制按钮或实时数据），在手机端即可实现极速轻量开发，所见即所得，弹指间实现应用开发。"]
					}, {
						"name": "平台",
						"text": ["支持iOS与Android系统手机端应用。"]
					}, {
						"name": "UI",
						"text": ["暂无信息"]
					}, {
						"name": "文档",
						"text": ["暂无信息"]
					}, {
						"name": "案例",
						"text": ["暂无信息"]
					}]
				},

				"/product/4_2": {
					"name": "必加锁",
					"icon": "iconfont icon-bijiasuo",
					"imgHead": __webpack_require__(655),
					"content": [{
						"name": "功能",
						"text": ["暂无信息"]
					}, {
						"name": "平台",
						"text": ["暂无信息"]
					}, {
						"name": "UI",
						"text": ["暂无信息"]
					}, {
						"name": "文档",
						"text": ["暂无信息"]
					}, {
						"name": "案例",
						"text": ["暂无信息"]
					}]

				},
				"/product/4_3": {
					"name": "闪钥",
					"icon": "iconfont icon-shanyue",
					"imgHead": __webpack_require__(659),
					"content": [{
						"name": "功能",
						"text": ["暂无信息"]
					}, {
						"name": "平台",
						"text": ["暂无信息"]
					}, {
						"name": "UI",
						"text": ["暂无信息"]
					}, {
						"name": "文档",
						"text": ["暂无信息"]
					}, {
						"name": "案例",
						"text": ["暂无信息"]
					}]

				},
				"/product/4_4": {
					"name": "物联网控制系统",
					"icon": "iconfont icon-wulianwangxitongpingtai",
					"imgHead": __webpack_require__(656),
					"content": [{
						"name": "功能",
						"text": ["这是一个物联网管理控制后台系统，与手机端Qiot智能控制软件同步数据，根据用户级别不同分为普通版、企业版与厂商版。普通版的管理控制后台主要用于设备管理及控制，企业版与厂商版更着重于用户管理与产品管理（进销存），还可以对用户的健康信息、使用习惯、地理位置分布以及产品使用状态、销售情况等进行统计与分析。我们还为企业版与厂商版提供增值定制服务，用户可根据需求对产品信息进行海量统计与多维度的大数据分析，为销售为用户体验提供更有价值的数据分析。"]
					}, {
						"name": "平台",
						"text": ["支持PC端应用。"]
					}, {
						"name": "UI",
						"text": ["暂无信息"]
					}, {
						"name": "文档",
						"text": ["暂无信息"]
					}, {
						"name": "案例",
						"text": ["暂无信息"]
					}]

				}
			}
		}

	}
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
	"imgNavPic": __webpack_require__(665),
	"aNavMenu": {
		"/support/1": {
			"name": "产品文档",
			"child": {
				"/support/1_1": {
					"name": "物联网链接器",
					"icon": "iconfont icon-wulianwanglianjieqi",
					"imgHead": __webpack_require__(301),
					"content": [{
						"name": "物联网链接器",
						"text": ["暂无信息"]
					}]
				},
				"/support/1_2": {
					"name": "Qiot物联网软件",
					"icon": "iconfont icon-QiotPro",
					"imgHead": __webpack_require__(664),
					"content": [{
						"name": "Qiot物联网软件",
						"text": ["暂无信息"]
					}]
				},
				"/support/1_3": {
					"name": "QLINK物联网模块",
					"icon": "iconfont icon-Qiotmokuai",
					"imgHead": __webpack_require__(301),
					"content": [{
						"name": "QLINK物联网模块",
						"text": ["暂无信息"]
					}]
				}
			}
		},
		"/support/2": {
			"name": "APP使用说明",
			"child": {
				"/support/2_1": {
					"name": "Qiot Pro",
					"icon": "iconfont icon-QiotPro",
					"isList": true,
					"imgHead": __webpack_require__(299),
					"content": [{
						"name": "功能特点",
						"child": [{
							"name": "特色功能",
							"text": ["1、开发模式设备：添加开发模式的设备，可自由选择设备类型，或者通过调试模式生成自定义界面；", "2、调试模式：与硬件进行双向控制解析，可将硬件收发的报文设置成UI控制界面；", "3、生成界面：将硬件收发的报文设置为开关或数据变量，自定义UI控制界面；", "4、采集设置：适用于不能主动请求数据的硬件，自定义设置请求报文及请求频率；", "5、存为产品：将已创建完UI控制界面的开发模式的设备保存为产品模板，可在产品列表管理该产品的系列号及其用户；", "6、产品管理：管理产品的系列号使用，并可查看用户使用信息。"]
						}, {
							"name": "功能特点",
							"text": ["1、轻量级快消品型智能家居APP的简单操作特点：扫描二维码添加硬件立即使用（如：JD超级APP，阿里小智、小米智能APP等。）；", "2、实现市场上主流的工程级智能家居系统特性，以及各种未知和各方硬件的复杂配置；", "3、APP具备产品管理，用户管理等功能；", "4、具备硬件智能化生产的条件；", "5、开发，分发一体解决方案；", "6、可视化开发，迅速快捷。"]
						}]
					}, {
						"name": "适用人群",
						"child": [{
							"name": "适用人群",
							"text": ["Qiot Pro 适合中小型智能硬件品牌商、智能家居工程商、极客&爱好者。"]
						}, {
							"name": "基础能力",
							"text": ["使用者必须具备一定的基础能力。如下：", "1、熟悉以太网TCP/IP，IP地址等；", "2、熟悉基本硬件知识，硬件串口，485总线、通讯报文等；", "3、有一定的硬件连接动手能力。", "如果不具备任何上述能力，请自行补习。"]
						}, {
							"name": "常见应用",
							"text": ["1、硬件双向控制解析；", "2、管理智能硬件。"]
						}]
					}, {
						"name": "操作指南",
						"text": ["建议查看Qiot Pro APP操作指南时结合手机实际操作，能够更好地帮助您快速上手。APP整体结构清晰明了，主界面显示设备控制、场景控制、定时任务三大块，也是核心的三大控制功能；左侧菜单可查看个人资料、系统消息、设置、用户列表、产品列表。"],
						"child": [{
							"name": "登录注册",
							"text": ["<b>[注册]</b>新用户注册时如果有邀请码则输入“@邀请码”，没有可以放空。使用邀请码注册的用户，将获得被邀请用户的所有设备控制权限。", "<b>[登陆]</b>使用已注册的账号登陆，输入手机账号及密码登陆。", "<b>[忘记密码]</b>通过手机短信验证码直接更改新密码。"]
						}, {
							"name": "添加设备",
							"text": ["注册时如果有邀请码则输入邀请码，没有可以放空。", "添加设备请点击右上角“+”进入添加页面,提供4种添加类型，类型不同创建的设备也有区别，可通过以下方法添加智能硬件：", "<b>[二维码扫描]</b>通过服务商得到智能硬件，扫描二维码后即可添加并绑定该设备。开启智能硬件并链接上网络，只需扫描智能硬件上的序列号二维码即可添加该硬件；", "<b>[系列号输入]</b>手动输入系列号添加智能硬件。添加的设备类型与二维码扫描一致，我们统称为智能产品；", "<b>[自定义]</b>通过模板生成空白设备，并配置设备控制命令。（单向，没有反馈）提供常见遥控器和继电器模板，可生成常见的控制器，生成后必须逐个设置按键发送的命令；", "<a href='/#/404'>查看APP使用步骤图</a>", "<b>[开发模式]</b>本系统特色功能之一,根据任意协议报文生成开关（设备操作）&数据变量（反馈界面）；点击该图标即可生成空白界面，初始化界面为空白无控件，在设备列表页面左滑开发模式的设备选择“调试模式”功能设置报文添加开关按键、指示灯、仪表等控件的功能。", "<a href='/#/404'>查看APP使用步骤图</a>"]
						}, {
							"name": "设备功能菜单",
							"text": ["通过扫一扫与系列号添加的设备都能直接控制，通过自定义与开发模式添加的设备则需要绑定QLINK的智能硬件配对WiFi后才可控制设备，需要在设备的功能菜单中操作。", "<b>功能菜单</b>：对该设备进行除页面控制命令外的其他功能操作。</b>", "当创建完设备后，进入到设备页。点击右上角的 “...”弹出操作菜单，根据不同的设备类型，菜单操作的功能也有差异。", "通过二维码扫描与系列号输入添加的智能产品可进行重命名、设备信息、WiFi配对的操作；", "通过自定义与开发模式添加的设备可进行重命名、设备信息、绑定设备、WiFi配对、学习模式、添加控件、采集设置、存为产品的操作。", "以下介绍更多菜单中的所有功能操作：", "<b>[重命名]</b>重新更改该设备的名称。", "<b>[设备信息]</b>查看该设备的详细信息，主要为2大块内容，从上往下依次为设备信息、命令信息。", "设备信息主要显示该设备的基本信息，含设备名称、设备类型、设备号、设备号类型、目标服务器、方式、端口。其中，目标服务器、方式、端口是重要链接信息，用于绑定设备。若添加设备为自定义或开发模式类型的设备，则必须自行链接互联网，链接该设备信息指向的目标地址，并上报序列号，上报后将建立通道，当该设备显示“在线”状态时表示可以正常使用。链接互联网时可通过PC版的“网络助手”软件来测试链接的情况，若觉得自行链接互联网复杂繁琐可以通过购买QLINK的物联网连接器或者物联网模块来快速实现与设备链接，无需设置，接入设备即可使用。立即购买 物联网链接器 物联网模块", "命令信息显示了所有按钮的控制命令。命令信息后缀的“（H）”与“（C）”是区分命令格式的标示，“（H）”表示该报文命令是 16进制命令，“（C）”则表示该报文命令是字符串命令。", "<b>[绑定设备]</b>绑定QLINK的物联网链接器或其他设备时使用。", "自定义与开发模式添加的设备，添加后是未绑定未配置的空设备暂时无法控制。可以自行购买以太网模块来实现互联网链接，或者购买QLINK物联网链接器轻松实现设备互联网链接，无需经过复杂设置调试，绑定时只需扫描QLINK连接器上的二维码，即插即用，方便快捷。", "<b>[WiFi配对]连接当前环境下的WiFi网络，当用户更换WiFi环境时则需要重新配对WiFi来链接互联网。", "如果绑定的设备是QLINK WiFi 模块,在绑定后会自动跳出WiFi配对功能完成配对，但是更换路由，或者更换设备地点就要经过此功能重新将WiFi模块和路由器配对链接。", "<b>[学习模式]</b>学习模式下，可以学习新的控制命令，旧命令将被覆盖。 ", "<a href='/#/404'>查看APP使用步骤图</a>", "自定义与开发模式添加的设备才有学习模式，进入学习模式后，原来的控制模式转化为学习模式，此时点击任意按键将跳出学习对话框，表示重新学习该按键命令。学习命令的对话框默认等待30秒，学习监听来自于硬件的报文，一旦接收到来自于硬件的报文会自动显示在该对话框中。然后点击“完成”旧命令将被本次监听的报文覆盖。", "学习命令功能可通过PC的网络助手上报控制报文，可以迅速地完成设置。除此之外，也可选择“手动配置”手动输入控制报文来完成设置。手动输入的报文默认为16进制，此时若点击右侧的（字符串）按钮则切换成字符串类型的报文输入。 ", "学习模式是单个按钮单次学习的，当学习成功或者点击取消时将恢复到正常控制模式。", "<b>[添加控件]</b>特色功能之一，仅开发模式类型的设备才可设置，自定义添加数据变量或开关。", "<a href='/#/404'>查看APP使用步骤图</a>", "添加控件功能需要配合QLINK物联网链接器使用，通过链接器监听设备发送的报文，将报文自定义为关键字、开关或数据变量控件，直接生成针对该智能硬件的控制界面，轻松完成轻量级的软件开发。", "具体操作如下：", "首先确保QLINK物联网链接器与智能硬件连接成功，点击添加控件进入调试模式，长按硬件发送的报文选择“生成界面”，", "<b>[采集设置]</b>特色功能之一，仅开发模式类型的设备才可设置，设置采集报文循环发送的时间。", "<a href='/#/404'>查看APP使用步骤图</a>", "采集设置是编辑采集频率并输入要发送的报文完成采集报文，点击添加后完成一条设置，添加成功的采集报文会显示在采集报文列表下方，可自由添加多条采集报文，也可向左滑动删除某条采集报文，设置完成后手机会自动设置的时间周期循环按报文列表的顺序逐个发送。", "采集设置的特色功能是让手机能根据指定的时间段来读取目标设备实时的状态，自定义报文按设定周期循环发送查询请求，得到后返回，可循环地刷新页面实时显示内容。特别对于无法主动发送状态的硬件，就可使用该功能来实现数据主动查询，使用非常实用便利。", "<b>[存为产品]</b>特色功能之一，仅开发模式类型的设备才可设置，将界面另存为产品供其他用户使用。", "<a href='/#/404'>查看APP使用步骤图</a>", "存为产品式直接将当前设备定义的界面保存为软件产品，它帮助了硬件工程商、软硬件从业者、硬件专家等在Qiot Pro 上就能够为自己的硬件定制化生成控制界面，不需要开发软件，而且不是独自使用，还可授权给其他用户使用，可以用于经营，销售，分享。", "目前，市场上常见的智能数码产品，都是批量生产，客户购买到产品后可以轻松使用软件来控制，简单到只需APP扫描二维码即可在APP上控制该硬件。而这些系统级的应用往往依赖于复杂的后台管理系统来实现。而要实现这样的功能是需要很多工作和时间的，大概流程为：开发->调试->软硬件联调->软件二次开发适配->库存管理->二维码生成->二维码绑定管理->二维码产品绑定->发放->鉴权->用户绑定->后台用户管理->后台设备管理->用户设备绑定关系管理。而后台管理系统按子系统又细分为：进销存系统、产品管系统、用户管理系统、智能配置系统等，整个流程中，在产品未销售前就需要经历很多的流程，大把的时间和金钱花在了产品开发上，而影响了产品后期销售利润及用户体验。所以，若自己完成一个智能产品的开发需要花费漫长的时间和巨大的人力物力。", "存为产品的功能是为实现上述功能而设计的，用户只需在Qiot Pro上简单操作如下步骤即可让产品直接卖给客户后通过软件扫描系列号二维码就能体验智能控制，让厂商能够把精力和重心放在宣传销售、用户体验与售后服务上。我们将流程不仅是简化，更是拉近了厂商与顾客之间的距离，整个流程如下：", "使用Qiot Pro创建开发模式设备->存为产品，保存已设置的设备->命名，生成产品型号->后台批量生成副本和对应系列号二维码（即产品仓库，可在手机端和PC端同步管理产品及用户） ->将序列号写入MCU，并将链接目标指向指定服务器；或者通过购买QLINK物联网链接模块无需设置直接与智能硬件连接->发放邀请码给用户，用户下载注册APP->用户购买该产品->扫描产品上的二维码获得该产品的控制APP", "不只是简化流程，是简单到只需点击“保存”即可完成产品软件开发及后台管理系统的开发，而且保存的产品会在主菜单的“产品列表”里，用户可在手机端管理产品及其用户。"]
						}, {
							"name": "设备控制",
							"text": ["在设备控制栏中显示了所有成功添加的设备，含二维码扫描或系列号输入添加的智能硬件、自定义添加的设备，以及开发模式生成的设备界面。", "<b>[设备控制]</b>根据创建设备的类型控制其智能硬件，与智能硬件进行远程交互控制。", "<b>[调试模式]</b>特色功能之一，此功能对于智能硬件开发的意义重大，方便调通智能硬件控制。", "在设备控制列表中，左滑自定义或开发模式类型的设备，显示“调试”和“删除”操作。", "调试模式：是手机端与该设备进行数据双向通讯。其特点是：", "1、 直接测试APP 某按键的控制命令是否有效；", "2、 使用PC端网络助手，通过PC传来命令，可直接将其复制进入学习模式后使用“手动配置”粘贴命令后即可设置成该按钮的控制命令，使用便捷，不需要手动输入命令，高效完成设置；", "3、 直接获取来自智能硬件发送的报文；", "4、 监听手机端与硬件端的通讯报文；", "5、 将报文生成设备控制界面。", "删除：即删除当前设备。", "其中，最为特殊的是“调试”功能，通过QLINK物联网链接器，使手机端与硬件端可以自由发送任意内容互相通讯。调试操作类似常见的即时聊天对话的软件一样，左边为硬件端，右边为手机端，格式如某信，下方为报文发送的输入框，手机端与硬件端就像聊天一样通讯，并保存即时通讯的消息内容，而且通讯的报文以及发送报文还可进行更多操作。", "通讯报文的操作：长按任意报文可对该报文进行复制、生成界面的功能，通讯报文显示还可切换字符类型模式。复制该报文，可黏贴至发送框内；生成界面可将报文的某段字节定义为关键字、开关、数据，保存后将生成针对该设备而定制的控制界面；顶部的16进制与字符串的按钮可切换整个对话框的字符类型，默认显示为16进制模式。", "<a href='/#/404'>查看APP使用步骤图</a>", "发送报文的操作：点击发送框右侧的“+”显示循环发送与清除的操作，用户使用“循环发送”功能可以指定时间段内让报文执行循环发送至设备端，使用“清除”功能可清除对话框内的所有通讯记录。", "<a href='/#/404'>查看APP使用步骤图</a>", "生成功能为开发模式的设备独有，用于定义协议解析规则。生成对应的UI界面，用户则不需要自己开发软件，使用Qiot Pro 简单操作就能极速的生成适应于该设备的控制界面。"]
						}, {
							"name": "场景控制",
							"text": ["场景控制是在现有可控设备的基础上，组合由单个或多个设备的多个控制命令为一键控制的操作。用户设定发送的控制命令以列表显示，可对每个控制命令设定执行的时间间隔。当点击场景开关时，将会按场景列表的顺序，并且根据每条控制命令的时间间隔逐个发送设定的控制命令。", "<a href='/#/404'>查看APP使用步骤图</a><a href='/#/404'>查看范例</a>", "添加场景操作简单，类似电商购物时添加到购物车方法一样。首先点击场景控制栏中右上角的“+”添加场景，显示当前已经创建成功的所有设备（与设备控制栏中显示的设备一致）；", "然后点击某个设备进入控制界面，选择某个按键命令，则会跳出对话框提示已经添加了该动作，是否继续添加场景动作，可选择“完成”结束场景命令编辑，或者选择“继续添加”可重复选择该设备的其他控制命令或者选择其他设备的控制命令；", "场景编辑过程中，可对列表中的所有控制命令随时更改时间间隔及删除操作。场景控制命令默认的时间间隔为2秒，可点击控制命令进行更改时间间隔，向左滑可对该控制命令进行删除操作，控制命令右侧的“三”号,可以自由拖动该控制命令进行上下移动排列顺序；", "点击完成后需给场景命令，保存场景结束本次场景的添加，完成一个场景创建，用户使用时只需点击该场景的“执行”按钮就可以实现一键轻松完成多个控制命令的操作。创建完成的场景在场景控制栏中以列表展示，除了“执行”操作还可向左滑对其进行删除或点击场景进行再次编辑。点击场景可查看该场景的控制命令列表，在右上角可点击“编辑”操作，可继续添加新控制命令、排序、删除的操作，操作与添加时一致。", "点击场景“执行”进行一键场景控制，执行成功时不会有任何提示，而失败时会有执行失败的提示。", "场景控制能够让用户生活中用电习惯以及重复操作的步骤简化成一键控制，高效优化了控制体验，也给用户生活带来便利及其良好用电习惯的养成。"]
						}, {
							"name": "定时任务",
							"text": ["定时任务是以设备的某个控制命令或某个场景为对象，设置某个时间点及循环周期，使其在某时间点可循环地执行控制的任务。", "<a href='/#/404'>查看APP使用步骤图</a><a href='/#/404'>查看范例</a>", "在定时任务栏中，在上方可切换设备定时与场景定时任务，若在设备定时任务页面中去点击右上角“+”创建的定时任务为设备定时任务，若在场景定时任务页面中去点击右上角“+”创建的定时任务则为场景定时任务。点击添加后进行选择定时任务的对象，设备定时选择的是某个按键控制，场景定时则选择某个场景即可；下一步进行定时设置，设定执行的时间点，设置执行的次数与重复规律，并设置执行时是否推送消息；最后保存命名即可完成定时任务创建。"]
						}, {
							"name": "个人中心",
							"text": ["在左侧菜单中可以查看到用户的账号信息，点击进入个人中心，可查看到更多用户的信息。", "<b>[个人资料]</b>显示用户的注册的账号信息，以及头像、昵称、ID、手机号、邮箱、性别资料。除账号信息外，其余信息可以更改。", "<b>[我的家人]</b>类似与分享功能，可将自有的所有设备控制权限分享给他人使用，一样可以执行所有设备控制。 ", "<a href='/#/404'>查看APP使用步骤图</a>", "用户在个人中心页面可查看到邀请码，记住邀请码告知需要分享的用户，让其注册时填入“@邀请码”注册账号，受邀的用户将显示在邀请人的“我的家人”列表中，长按对象可对家人成员进行删除。", "<b>[信息中心]</b>系统推送的消息内容，可自由删除。 ", "<b>[反馈]</b>可编辑意见或建议发送给我们，支持我们更好的改良用户体验及交互。 "]
						}, {
							"name": "产品管理",
							"text": ["特色功能之一， 产品列表页显示所有 “开发模式”和“空设备”类型设备可以使用“存为产品”的功能将控制界面存为产品模板，产品列表页则显示所有产品模板 。", "<a href='/#/404'>查看APP使用步骤图</a>", "有了产品模板就可复制创建无数产品副本，产品包含链接服务器的序列号凭据。可将序列号或者二维码写入智能硬件用于回复服务器鉴权，并将二维码贴在智能硬件上即可销售。用户购买到手使用Qiot Pro直接扫描二维码即可添加该产品副本，并且和模板设备毫无冲突，可自由控制该智能硬件。（貌似信息量很大？画个草图） ", "从产品开发的角度可以理解为：产品模板即为产品原型，通过此原型复制（量产）出副本，给用户，自己直接使用，而无需再经历第一次创建时费脑的协议解析设置，简单到用APP扫描生成的二维码即可使用，并完成服务器的鉴权和自动设置好用户设备的绑定关系。 ", "从行业工程应用角度可理解为：面对工程方案多样化的部署，按传统的硬件、协议、用户、配置、绑定等同时需要创建无数表格、纸质、协议库列表等来管理，难以管理和交接，而模板化解决了这些问题。编写过的硬件通过该功能，管理硬件，可重复使用，用户自行绑定，关联关系一目了然。", "导航==》如何绑定，见用户列表。 ", "产品列表，左拉产品项的详细信息可显示保存的产品信息和协议设定规则。 Qiot Pro之所以能适配所有硬件，生成产品，是因为可对任意协议进行解析规则设定。 原理：通过设定报文的 报头关键字、开关标记位、量值等参数生成可读的UI界面；再通过界面生成的控件，设定控件发送的控制字；并保存为产品模板，用于批量生产。 解释如下： 产品名称由调试时生成的时候输入，有利于记住设定的协议规则。 条形码即为系统生成的产品唯一码。用于快速找到该产品。 采样间隔设置： 通常，获得设备状态当前状态有两大方法。 常见的大多数简单传感器都是有周期性的上报当前传感器值，该值会自动传送于手机，通过设定可以解析为明文；所有无需去做采样设置； 对于功能多样化的高级设备，经常需要按需去发送查询指令获得反馈值，如：查询目标设备开关状态、发送开关查询指令，查询水位值发送水位查询指令等。 如果手动去发送这些值，难免繁琐啰嗦。所以，Qiot Pro设定为周期性的循环发送查询指令，让目标设备返回当前所查询的值以被解析。 例如界面实例： 能见三条，意思为，进入设备后手机默认发送 第一条“aaccbb”，停留“1S”后，接着发送“bbccdd”，停留2S后，继续发送“112233”，停留“3S”后，回头继续发送第一条“aaccbb”，停留1S，继续往下发送；如此循环。 但设定的查询正确，设备将应答查询命令，通过下列获得解析：如下： 原始代码： 用户通过手动或者截获下位机传上来的协议原文。 通过设定该报文来设定手机的解析规则，同时生成界面。 下方稍大字体即为设定过的解析规则； 点击每个段落，下方将切换显示该段落设定的规则。 如实例设定的规则是： 1122：报文的关键字是1122，切该关键字位于报文的 1、2字节处（*注），如果传上来的报文符合关键字定义且位于 1、2字节处，那么该报文将被解析，后续解析规则成立；否则忽略该报文。 33：该段落被忽略； 99 F8：该报文已设定为“开关”，位于 4、5字节处，大端表达，有效位数为9位。 详解：大多数智能硬件用 二进制来表达硬件的各种开关的工作状态。例如，空调的各种状态：开着还是关着，制冷还是制热，摆风是否打开，是否打开除湿等等；空调上通常有指示灯来显示这些状态，但显示到手机呢，是通过二进制，其二进制为 0或者1来表达，很直观，0就是关，1就是开； 将此报文定义了2个字节开关作为表达，最多可以表达 16个开关，通常用不了那么多；所有，上述有个“有效位”来描述开关用了16个中的几个以便显示出来；上述 99 F8用Windows计算器可计算出二进制结果(如图)：?1001100111111000?，那么16个开关状态有了 手机会将这16个开关显示出来，但是显示是从左到右显示还是从右到左，此时大小端状态生效（或称高低位在前在后）；再者16个开关是上限，有些硬件用不了那么多，所以就有了有效位，系统将忽略掉有效位以外内容。 E0 CF:该报文设定为“变量”，变量名为UI显示的名称，大端表示，数值从左边读到右边，上下限意显示在界面上该值的范围，如 1-100；比例100；单位为“升”；左边为该项的显示样式； 他产生一个 仪表盘，刻度范围是 1-100；显示在仪表上的指针为；该真实值16进制转化为10进制后除以100得出的结果。E0 CF用大端表达，从左边读到右边，计算器计算后结果57551；除以100得出，575.51。但是仪表盘设置的范围为1-100；所以超出范围而出现呈现红色爆表状态。 其他以此类推，可设置多个。 删除即可删除该产品，并且连同产品下的序列号也全部删除，包括已绑定的产品。 点击“》”可进入该产品下的序列号列表，如没有序列号，或者都已绑定，可点击右上角“+”添加序列号。 每个栏显示了产品副本的基本信息，如：序列号、创建时间、是否绑定等。上方标签可切换绑定表和未绑定表。如已绑定，将显示绑定用户的账号。序列号可通过网站 http://qlink.cc 登陆后导出，可打印标签。 点击序列号可进入查看产品副本详情，图； 分发序列号给用户注册可以截屏，将此页面通过其他聊天工具发送给对方，对方可轻易绑定。如已绑定，右上角可查看绑定的用户，也可解除该用户的绑定。 左拉动序列号栏可删除序列号。"]
						}, {
							"name": "用户列表",
							"text": ["对于硬件开发者、小微型硬件企业、智能家居从业人员；往往会出现批量出货等需求；Qiot Pro也满足这些需求；Qiot Pro同时也是一套小型发布系统，可用于管理用户&产品。 方法为：发放邀请码，让用户注册，用户注册后即出现在用户列表。可管理用户，产品和产品用户的绑定关系。 如图：在 十三节的个人中心，点击用户头像可见“邀请码”，将此号码发放给用户，用户注册后即可显示在用户列表。具体为：注册的时候邀请码框输入 “#邀请码” 如图：左拉动用户栏可见操作：分别是“删除”和“列出产品“；其中删除即删除这个用户；列出产品了列出出售后，用户绑定的产品。 点击可进入查看基本用户情况。"]
						}]
					}]
				},
				"/support/2_2": {
					"name": "必加锁",
					"icon": "iconfont icon-bijiasuo",
					"imgHead": __webpack_require__(300),
					"content": [{
						"name": "必加锁",
						"text": ["暂无信息"]
					}]
				},
				"/support/2_3": {
					"name": "闪钥",
					"icon": "iconfont icon-shanyue",
					"imgHead": __webpack_require__(302),
					"content": [{
						"name": "闪钥",
						"text": ["暂无信息"]
					}]
				}
			}
		},
		"/support/3": {
			"name": "APP下载",
			"child": {
				"/support/3_1": {
					"name": "Qiot Pro",
					"icon": "iconfont icon-QiotPro",
					"imgHead": __webpack_require__(299),
					"content": [{
						"name": "Qiot Pro物联网控制软件 ",
						"text": [__webpack_require__(661), "", "QIOT Pro意为快速连接，快速物连。QIOT 品牌全称是QLink Control System.就是快控制系统，快联控制器。本App即为控制端，用手机控制一切电器", "QIOT Pro为智能家居、自动化控制提供一套绝对简单的控制方法。无需任何技术基础，无需任何编程，QIOT甚至可以无需购买任何产品即可控制电器！你只需在PC端输入被控设备的控制指令；手机即生成控制按键。当然，购买QLink硬件产品的话，PC端配置都可省略。", "QIOT Pro面向：", "*系统集成工程商——通过QIOT Pro，你们大可不必购买昂贵中控品牌。有了QIOT Pro，你们甚至可以不用中控。也用不着培训；没有门槛。", "*电子产品商——通过QIOT Pro，你们的产品可以拥有手机控制端！甚至“QIOT Pro”都改成你们的品牌；不用做项目。马上可实现。", "*硬件通讯开发者——通过QIOT Pro，你们可以不必再写App。填入指令即可随心所测（控）", "*玩具业——让所有玩具都变成手机控吧", "*爱好者——可以把你所有电器、电子产品整成手机控制。", "使用微信扫描时，点击右上角“···”，使用浏览器打开进行下载。", __webpack_require__(660)]
					}]
				},
				"/support/3_2": {
					"name": "必加锁",
					"icon": "iconfont icon-bijiasuo",
					"imgHead": __webpack_require__(300),
					"content": [{
						"name": "必加锁  ",
						"text": ["必加锁App是一款新型的环境友好型锁，可通过手机二维码扫描直接实现开锁，无卡无钥匙。使开锁方式简单快捷。", "必加锁APP可管理多把锁、一把锁可分发多把钥匙。应用非常广泛！多功能移动前台，便捷酒店管理；出租房管理，随时随地轻松搞定；简单实现员工考勤；家里熊孩子什么时间回家的，在外出差的父母也能真实掌握...", "科技从未停止它改变世界的脚步，二维码时代的到来是一场新的革命，它将开启我们新的生活方式。必加锁App，操作简单、便捷随意、安全，让我们开启一段属于大家的便捷旅程吧。", __webpack_require__(650)]
					}]
				},
				"/support/3_3": {
					"name": "闪钥",
					"icon": "iconfont icon-shanyue",
					"imgHead": __webpack_require__(302),
					"content": [{
						"name": "闪钥   ",
						"text": [__webpack_require__(663), "", "闪钥app是一款扫描二维码就能实现开锁甚至远程遥控开锁的新概念产品。", "通过调用手机照相功能，闪钥将快速而精确地扫描识别二维码所对应锁的信息，实现智能开锁。", "将你的手机变成一把专业的多功能钥匙，从根本上解决忘带钥匙的烦恼，即使远隔千里也能实现在家招待客人的愿望，真正地实现智能化生活。", "闪钥app,一款将你们开启人生明亮之门的app。它将会是你们不可或缺生活贴心小帮手！", __webpack_require__(662)]
					}]
				}
			}
		}

	}
};

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);

var Promise = __webpack_require__(306).Promise;






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
	state: {
		"oServerUrl": {
			"base": "",
			"api": {}
		},
		"oHomePage": {
			index: 1,
			size: 6,
			oFirstFire: null
		},
		"aIndexMenu": {
			"home": {
				"name": "首页",
				"path": "/"
			},
			"solution": {
				"name": "解决方案",
				"path": "/solution",
				"sub": {
					"2_1": {
						"name": "热门解决方案",
						"path": ""
					},
					"2_2": {
						"name": "行内解决方案",
						"path": ""
					},
					"2_3": {
						"name": "受益用户",
						"path": ""
					}
				}
			},
			"product": {
				"name": "产品&服务",
				"path": "/product",
				"sub": {
					"3_1": {
						"name": "接入服务",
						"path": "/product"
					},
					"3_2": {
						"name": "云主机",
						"path": "/product/2"
					},
					"3_3": {
						"name": "物联网模块",
						"path": "/product/3_1"
					},
					"3_4": {
						"name": "物联网链接器",
						"path": "/product/3_2"
					},
					"3_5": {
						"name": "Qiot Pro",
						"path": "/product/4_1"
					},
					"3_6": {
						"name": "物联网控制系统",
						"path": "/product/4_2"
					}
				}
			},
			"casus": {
				"name": "客户案例",
				"path": "/casus"
			},
			"support": {
				"name": "技术支持",
				"path": "/support/1_1",
				"sub": {
					"5_1": {
						"name": "产品文档",
						"path": "/support/1_1"
					},
					"5_2": {
						"name": "APP使用说明",
						"path": "/support/2_1"
					},
					"5_3": {
						"name": "APP下载",
						"path": "/support/3_1"
					}
				}
			},
			"about": {
				"name": "关于我们",
				"path": "/about",
				"sub": {
					"6_1": {
						"name": "公司简介",
						"path": "/about"
					},
					"6_2": {
						"name": "联系我们",
						"path": "/about/2"
					},
					"6_3": {
						"name": "新闻动态",
						"path": "/about/3_1"
					},
					"6_4": {
						"name": "加入我们",
						"path": "/about/4_1"
					},
					"6_5": {
						"name": "物联网初创企业成长计划",
						"path": "/about/5"
					}
				}
			}
		}
	},
	mutations: {
		homeNext: function homeNext(state) {
			if (state.oHomePage.index < state.oHomePage.size) {
				state.oHomePage.index += 1;
				state.oHomePage.oFirstFire = setTimeout(function () {
					state.oHomePage.oFirstFire = null;
				}, 400);
			}
		},
		homeBefore: function homeBefore(state) {
			if (state.oHomePage.index > 1) {
				state.oHomePage.index -= 1;
				state.oHomePage.oFirstFire = setTimeout(function () {
					state.oHomePage.oFirstFire = null;
				}, 400);
			}
		}
	},
	getters: {
		mobile: function mobile(state) {
			return true;
		}
	}
});



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter("dataFormat", function (value) {
	return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).format("YYYY年MM月DD日 hh:mm");
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.dataFormat = function (value, format) {
	return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).format(format);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.fnToRouter = function (router) {
	if (router == "/") {
		this.$store.state.oHomePage.index = 1;
	}
	this.$router.push(router);
	window.scrollTo(0, 0);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.fnToWebPage = function (url) {
	window.location.href = url;
};

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
	el: '#app',
	store: store,
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 190,
	"./af.js": 190,
	"./ar": 196,
	"./ar-dz": 191,
	"./ar-dz.js": 191,
	"./ar-ly": 192,
	"./ar-ly.js": 192,
	"./ar-ma": 193,
	"./ar-ma.js": 193,
	"./ar-sa": 194,
	"./ar-sa.js": 194,
	"./ar-tn": 195,
	"./ar-tn.js": 195,
	"./ar.js": 196,
	"./az": 197,
	"./az.js": 197,
	"./be": 198,
	"./be.js": 198,
	"./bg": 199,
	"./bg.js": 199,
	"./bn": 200,
	"./bn.js": 200,
	"./bo": 201,
	"./bo.js": 201,
	"./br": 202,
	"./br.js": 202,
	"./bs": 203,
	"./bs.js": 203,
	"./ca": 204,
	"./ca.js": 204,
	"./cs": 205,
	"./cs.js": 205,
	"./cv": 206,
	"./cv.js": 206,
	"./cy": 207,
	"./cy.js": 207,
	"./da": 208,
	"./da.js": 208,
	"./de": 210,
	"./de-at": 209,
	"./de-at.js": 209,
	"./de.js": 210,
	"./dv": 211,
	"./dv.js": 211,
	"./el": 212,
	"./el.js": 212,
	"./en-au": 213,
	"./en-au.js": 213,
	"./en-ca": 214,
	"./en-ca.js": 214,
	"./en-gb": 215,
	"./en-gb.js": 215,
	"./en-ie": 216,
	"./en-ie.js": 216,
	"./en-nz": 217,
	"./en-nz.js": 217,
	"./eo": 218,
	"./eo.js": 218,
	"./es": 220,
	"./es-do": 219,
	"./es-do.js": 219,
	"./es.js": 220,
	"./et": 221,
	"./et.js": 221,
	"./eu": 222,
	"./eu.js": 222,
	"./fa": 223,
	"./fa.js": 223,
	"./fi": 224,
	"./fi.js": 224,
	"./fo": 225,
	"./fo.js": 225,
	"./fr": 228,
	"./fr-ca": 226,
	"./fr-ca.js": 226,
	"./fr-ch": 227,
	"./fr-ch.js": 227,
	"./fr.js": 228,
	"./fy": 229,
	"./fy.js": 229,
	"./gd": 230,
	"./gd.js": 230,
	"./gl": 231,
	"./gl.js": 231,
	"./he": 232,
	"./he.js": 232,
	"./hi": 233,
	"./hi.js": 233,
	"./hr": 234,
	"./hr.js": 234,
	"./hu": 235,
	"./hu.js": 235,
	"./hy-am": 236,
	"./hy-am.js": 236,
	"./id": 237,
	"./id.js": 237,
	"./is": 238,
	"./is.js": 238,
	"./it": 239,
	"./it.js": 239,
	"./ja": 240,
	"./ja.js": 240,
	"./jv": 241,
	"./jv.js": 241,
	"./ka": 242,
	"./ka.js": 242,
	"./kk": 243,
	"./kk.js": 243,
	"./km": 244,
	"./km.js": 244,
	"./ko": 245,
	"./ko.js": 245,
	"./ky": 246,
	"./ky.js": 246,
	"./lb": 247,
	"./lb.js": 247,
	"./lo": 248,
	"./lo.js": 248,
	"./lt": 249,
	"./lt.js": 249,
	"./lv": 250,
	"./lv.js": 250,
	"./me": 251,
	"./me.js": 251,
	"./mi": 252,
	"./mi.js": 252,
	"./mk": 253,
	"./mk.js": 253,
	"./ml": 254,
	"./ml.js": 254,
	"./mr": 255,
	"./mr.js": 255,
	"./ms": 257,
	"./ms-my": 256,
	"./ms-my.js": 256,
	"./ms.js": 257,
	"./my": 258,
	"./my.js": 258,
	"./nb": 259,
	"./nb.js": 259,
	"./ne": 260,
	"./ne.js": 260,
	"./nl": 262,
	"./nl-be": 261,
	"./nl-be.js": 261,
	"./nl.js": 262,
	"./nn": 263,
	"./nn.js": 263,
	"./pa-in": 264,
	"./pa-in.js": 264,
	"./pl": 265,
	"./pl.js": 265,
	"./pt": 267,
	"./pt-br": 266,
	"./pt-br.js": 266,
	"./pt.js": 267,
	"./ro": 268,
	"./ro.js": 268,
	"./ru": 269,
	"./ru.js": 269,
	"./se": 270,
	"./se.js": 270,
	"./si": 271,
	"./si.js": 271,
	"./sk": 272,
	"./sk.js": 272,
	"./sl": 273,
	"./sl.js": 273,
	"./sq": 274,
	"./sq.js": 274,
	"./sr": 276,
	"./sr-cyrl": 275,
	"./sr-cyrl.js": 275,
	"./sr.js": 276,
	"./ss": 277,
	"./ss.js": 277,
	"./sv": 278,
	"./sv.js": 278,
	"./sw": 279,
	"./sw.js": 279,
	"./ta": 280,
	"./ta.js": 280,
	"./te": 281,
	"./te.js": 281,
	"./tet": 282,
	"./tet.js": 282,
	"./th": 283,
	"./th.js": 283,
	"./tl-ph": 284,
	"./tl-ph.js": 284,
	"./tlh": 285,
	"./tlh.js": 285,
	"./tr": 286,
	"./tr.js": 286,
	"./tzl": 287,
	"./tzl.js": 287,
	"./tzm": 289,
	"./tzm-latn": 288,
	"./tzm-latn.js": 288,
	"./tzm.js": 289,
	"./uk": 290,
	"./uk.js": 290,
	"./uz": 291,
	"./uz.js": 291,
	"./vi": 292,
	"./vi.js": 292,
	"./x-pseudo": 293,
	"./x-pseudo.js": 293,
	"./yo": 294,
	"./yo.js": 294,
	"./zh-cn": 295,
	"./zh-cn.js": 295,
	"./zh-hk": 296,
	"./zh-hk.js": 296,
	"./zh-tw": 297,
	"./zh-tw.js": 297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 631;

/***/ }),
/* 632 */,
/* 633 */,
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_menu_title.6d5acf5.png";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/公司简介.c40b66a.png";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/初创企业成长计划.d622c6a.png";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/产品智能化流程_详情_01.42b02b5.png";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/产品智能化流程_详情_02.a1d4345.png";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/产品智能化流程_详情_03.8406870.png";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/玩转产品智能化发展进阶攻略_详情_01.d8cb1de.png";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/玩转产品智能化发展进阶攻略_详情_02.1cab988.png";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/玩转产品智能化发展进阶攻略_详情_03.51e2375.png";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/玩转产品智能化发展进阶攻略_详情_04.7ce0268.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/玩转产品智能化发展进阶攻略_详情_05.26cbd00.png";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/加入我们-校园招聘.bdfe9a1.png";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/加入我们-社会招聘.1d0d159.png";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/新闻动态-产品更新.161adee.png";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/新闻动态-最新动态.f19032e.png";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/联系我们.9653635.png";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bijiasuo_erweima.e272ec4.png";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Qiotpro.0901343.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iot接入服务.a5580cf.png";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/product_menu_title.4c6c2d7.png";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/云主机.39877a2.png";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/必加锁.6ab06b9.png";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/物联网控制系统.192d0fd.png";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/物联网模块.049c8b2.png";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/物联网链接器.f2e7a83.png";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/闪钥.f9a3761.png";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qiot_erweima.6918dac.png";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qiot_logo.e7aaae7.png";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shanyao_erweima.2af8406.png";

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shanyao_logo.84cfeec.png";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Qiot物联网软件.e2bc118.png";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/support_menu_title.f2d8fce.png";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_1.3824b36.png";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_10.251b801.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_11.7c043e6.png";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_12.85b1a6a.png";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_2.76c66e0.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_3.3142d4b.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_4.a63eae5.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_5.613c416.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_6.dc2f670.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_7.eec3852.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_8.e855939.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list_9.094cc95.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_1.8e5e165.png";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_2.e085e37.png";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_3.cae6d03.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_4.0bf32ab.png";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic_bg.48b8121.jpg";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic_development.751ff91.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pic_version.1da4f53.png";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pone.070f91e.png";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smartlock_banner_1.76f4857.png";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smartlock_banner_2.2a16f32.png";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/smartlock_banner_3.7a847bc.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_1.93f97c9.png";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_1_hover.d9e5752.png";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_2.58e4b86.png";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_2_hover.52e34c5.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_3.6f53575.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_3_hover.381e423.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_4.8728310.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2_4_hover.0fff94e.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3_1.626be12.png";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3_1_hover.e81a634.png";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3_2.38c44e4.png";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3_2_hover.69ead01.png";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3_3.4d52dbd.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3_3_hover.17052ad.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_1.9293d5a.png";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_1_hover.acde458.png";

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_2.e6fef03.png";

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_2_hover.2e7ae4e.png";

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_3.80a0426.png";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_3_hover.e1da22f.png";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_4.fcdc64c.png";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4_4_hover.d685228.png";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5_1.59192d9.png";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5_1_hover.0e83b3d.png";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5_2.4d2668f.png";

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5_2_hover.90ecad1.png";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5_3.cd8ffcd.png";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5_3_hover.3b5d265.png";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/benner_material_1.23b06b7.png";

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/code_android.2075a54.png";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/code_ios.4236d14.png";

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jiantou.f87044d.png";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/klk.032c64d.jpg";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_2.1ee738d.png";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.2e94ee3.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phone.38a2fe9.png";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/toNext.d8c7c0f.png";

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.8bb1cf3.png";

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/toTop.555cd57.png";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_1.9af5d6e.png";

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_1_hover.1231726.png";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_2.ee1dd4f.png";

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_2_hover.05d89ab.png";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_3.f5599f3.png";

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_3_hover.bebabbf.png";

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_4.caacc10.png";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardlist_4_hover.962baf4.png";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guanyu.9ce1ae5.png";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guanyu_hover.e085e37.png";

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jianlin.1a462c4.png";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jianlin_hover.8e5e165.png";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shuchuang.97d4aab.png";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shuchuang_hover.cae6d03.png";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tab_1_banner.fa3565a.png";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tab_2_banner.4981854.png";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tab_3_banner.6de2482.png";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tab_4_banner.1dac875.png";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tab_5_banner.a060d89.png";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title_img.c07fe4b.png";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhongpu.fd4ca90.png";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhongpu_hover.aefc83a.png";

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(620)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(621)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  "data-v-47fabd2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  "data-v-420434f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  "data-v-11237119",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  "data-v-3b58f3a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  "data-v-543c8bb3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  "data-v-25e93685",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(613)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  "data-v-4fb1ff6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "point-list"
  }, _vm._l((_vm.$store.state.oHomePage.size), function(i) {
    return _c('div', {
      staticClass: "point",
      class: {
        active: i == _vm.$store.state.oHomePage.index
      },
      on: {
        "click": function($event) {
          _vm.$store.state.oHomePage.index = i
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "page-group",
    style: ({
      transform: 'translateY(-' + ((_vm.$store.state.oHomePage.index - 1) * 100) + 'vh)'
    })
  }, [_c('page_1'), _vm._v(" "), _c('page_2'), _vm._v(" "), _c('page_3'), _vm._v(" "), _c('page_4'), _vm._v(" "), _c('page_5'), _vm._v(" "), _c('page_6')], 1)])
},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "support"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('nav-menu', {
    attrs: {
      "bgNav": _vm.imgNavPic,
      "menu": _vm.aNavMenu
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "text"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgHead
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [(_vm.isList) ? [_c('div', {
    staticClass: "lists"
  }, [_c('lists-menu', {
    attrs: {
      "menu": _vm.aArticle
    }
  })], 1)] : [_c('div', {
    staticClass: "tabs"
  }, [_c('tabs-menu', {
    attrs: {
      "menu": _vm.aArticle
    }
  })], 1)]], 2)])])], 1)], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lists-menu"
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "article",
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "article_txt",
    staticStyle: {
      "min-height": "200vh"
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return [_c('h2', {
      staticClass: "article_title"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.text), function(i) {
      return (item.text) ? [(i.indexOf('data:image') >= 0 || i.indexOf('png') >= 0) ? _c('div', {
        staticClass: "img_box"
      }, [_c('img', {
        attrs: {
          "src": i
        }
      })]) : _c('div', {
        staticClass: "p_box"
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(i)
        }
      })])] : _vm._e()
    }), _vm._v(" "), _vm._l((item.child), function(it, id) {
      return [_c('h3', {
        staticClass: "article_title_sub",
        attrs: {
          "index": index + '-' + id
        }
      }, [_c('i', {
        staticClass: "el-icon-caret-right"
      }), _vm._v(_vm._s(it.name))]), _vm._v(" "), _vm._l((it.text), function(i) {
        return (it.text) ? [(i.indexOf('data:image') >= 0 || i.indexOf('png') >= 0) ? _c('div', {
          staticClass: "img_box"
        }, [_c('img', {
          attrs: {
            "src": i
          }
        })]) : _c('div', {
          staticClass: "p_box"
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(i)
          }
        })])] : _vm._e()
      })]
    })]
  }), _vm._v(" "), _c('h2')], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-menu', {
    staticClass: "article_menu",
    class: {
      isFixed: _vm.isFixed
    },
    attrs: {
      "default-active": _vm.list_active,
      "unique-opened": ""
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return [_c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-menu-item-group', [_vm._l((item.child), function(it, id) {
      return [_c('el-menu-item', {
        attrs: {
          "index": index + '-' + id
        }
      }, [_vm._v(_vm._s(it.name))])]
    })], 2)], 2)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('nav-menu', {
    attrs: {
      "bgNav": _vm.imgNavPic,
      "menu": _vm.aNavMenu
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "text"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgHead
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('tabs-menu', {
    attrs: {
      "menu": _vm.aArticle
    }
  })], 1)])])])], 1)], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "img_material",
    attrs: {
      "src": _vm.img.material
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_next",
    attrs: {
      "src": _vm.img.next
    },
    on: {
      "click": function($event) {
        _vm.$store.state.oHomePage.index += 1
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("选择‘酷联客’物联网应用方案，唯快不破")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("我们专业提供设备智能化、物联网控制解决方案")])])
}]}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-group"
  }, [_vm._l((_vm.aCardGroup), function(item, index) {
    return [(index != 0) ? _c('div', {
      staticClass: "jiantou"
    }, [_c('img', {
      attrs: {
        "src": _vm.img.jiantou
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, [_c('img', {
      attrs: {
        "src": item.img
      },
      on: {
        "mouseover": function($event) {
          _vm.fnImageHover(item, index)
        },
        "mouseout": function($event) {
          _vm.fnImageHover(item, index)
        }
      }
    })])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sDesc.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sDesc.desc))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("查看详情")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("产品智能化进阶")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("每个版本都是一个弹性方案都可无缝升级，从智能控制到运营规划，Qiot方案全线满足")])])
}]}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.cardList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "card",
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.desc))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          _vm.fnToRouter('/404')
        }
      }
    }, [_vm._v(_vm._s(item.btn.name))])])])])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("QLink物联网方案特色")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("设备端+云端+移动端，智能产品在这里无需开发")])])
}]}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.cardList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "card",
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.desc))])])])])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("产品&服务")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("我们以用户的需求主导产品研发，提供丰富、高性能、稳定的产品和服务")])])
}]}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(719)
    }
  }), _vm._v(" "), _c('el-button', {
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-ios"
  }), _vm._v(" iOS\n\t\t\t")])], 1), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(718)
    }
  }), _vm._v(" "), _c('el-button', {
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-anzhuo"
  }), _vm._v("Android")])], 1)], 1), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(item.desc))])])
  })), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(724)
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "src": __webpack_require__(722)
    }
  }), _vm._v(" "), _c('div', [_vm._v("物联网控制APP")]), _vm._v(" "), _c('div', [_vm._v("智能生活·一手掌握")])])
}]}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page_6"
  }, [_c('div', {
    staticClass: "panel",
    style: ({
      backgroundImage: 'url(' + _vm.imgBg + ')'
    })
  }, [_c('h1', [_vm._v("马上预约一次现场演示")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogMap = true
      }
    }
  }, [_vm._v("查看地图位置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogInfo = true
      }
    }
  }, [_vm._v("获取DEMO")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('foot'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "show-close": false,
      "modal-append-to-body": false,
      "size": "small"
    },
    model: {
      value: (_vm.dialogInfo),
      callback: function($$v) {
        _vm.dialogInfo = $$v
      },
      expression: "dialogInfo"
    }
  }, [_c('div', [_c('h3', [_vm._v("获取DEMO"), _c('small', [_vm._v("想要预约一次现场演示，领取DEMO，请填写表格")])]), _vm._v(" "), _c('el-form', {
    ref: "formData",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.formData.name = $$v
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "phone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.formData.phone = $$v
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "company",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "公司名称"
    },
    model: {
      value: (_vm.formData.company),
      callback: function($$v) {
        _vm.formData.company = $$v
      },
      expression: "formData.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "需求",
      "prop": "demand",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "需求"
    },
    model: {
      value: (_vm.formData.demand),
      callback: function($$v) {
        _vm.formData.demand = $$v
      },
      expression: "formData.demand"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogInfo = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "large",
      "show-close": false,
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogMap),
      callback: function($$v) {
        _vm.dialogMap = $$v
      },
      expression: "dialogMap"
    }
  }, [_c('BMap')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('label', [_vm._v("我们在这里")]), _vm._v("\n\t\t厦门市湖里区园山南路806号\n\t\t"), _c('span', [_vm._v("|")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-youxiang"
  }), _vm._v("qlink@qlink.cc\t\t\t\n\t\t"), _c('span', [_vm._v("|")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-shouji"
  }), _vm._v("0592-8222272\n\t\t"), _c('i', {
    staticClass: "iconfont icon-weihu"
  }), _vm._v("终身故障维护\n\t\t"), _c('i', {
    staticClass: "iconfont icon-liaotian"
  }), _vm._v("7×24小时售后支持\n\t\t"), _c('i', {
    staticClass: "iconfont icon-mian"
  }), _vm._v("软件永久免费\n\t")])
}]}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-menu"
  }, [(_vm.menu.length != 1) ? _c('el-tabs', {
    staticClass: "article_tab",
    class: {
      fixed: _vm.isFixed
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab_active),
      callback: function($$v) {
        _vm.tab_active = $$v
      },
      expression: "tab_active"
    }
  }, [_vm._l((_vm.menu), function(item, i) {
    return [_c('el-tab-pane', {
      attrs: {
        "name": item.name,
        "index": i,
        "label": item.name
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.menu.length != 1) ? _c('div', {
    staticStyle: {
      "padding-top": "60px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article_txt"
  }, [_vm._l((_vm.menu), function(item) {
    return [_c('h3', {
      staticClass: "article_title"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.text), function(i) {
      return [(i.indexOf('data:image') >= 0 || i.indexOf('png') >= 0 || i.indexOf('jpg') >= 0) ? _c('div', {
        staticClass: "img_box"
      }, [_c('img', {
        attrs: {
          "src": i
        }
      })]) : _c('div', {
        staticClass: "p_box"
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(i)
        }
      })])]
    })]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Hello World")])
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('nav-menu', {
    attrs: {
      "bgNav": _vm.imgNavPic,
      "menu": _vm.aNavMenu
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "text"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgHead
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('tabs-menu', {
    attrs: {
      "menu": _vm.aArticle
    }
  })], 1)])])])], 1)], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "casus"
  }, [_c('div', {
    staticClass: "card_1",
    style: ({
      backgroundImage: 'url(' + _vm.img.bgCard_1 + ')'
    })
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    staticClass: "phone_border",
    attrs: {
      "src": __webpack_require__(685)
    }
  }), _vm._v(" "), _vm._l((_vm.aPointImgList), function(item, i) {
    return [_c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [(_vm.iPointIndex == (i + 1)) ? _c('img', {
      staticClass: "phone_content",
      attrs: {
        "src": _vm.aPointImgList[i]
      }
    }) : _vm._e()])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "point-list"
  }, [_vm._l((_vm.aPointImgList.length), function(i) {
    return [_c('div', {
      staticClass: "point",
      class: {
        active: _vm.iPointIndex == i
      },
      on: {
        "click": function($event) {
          _vm.fnPointClick(i)
        }
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card_2",
    style: ({
      backgroundImage: 'url(' + _vm.img.bgCard_2 + ')'
    })
  }, [_c('h1', [_vm._v("智能软件制定开发")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', [_vm._v("针对各行业业务特性，打造个性化行业解决方案，为客户提供一站式的产品与服务。")]), _vm._v(" "), _c('p', [_vm._v("让客户可以轻松实现物联网产品的开发和管理，让产品互联互通。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(684)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card_3"
  }, [_c('h1', [_vm._v("案例展示")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', [_vm._l((_vm.aList), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])])]
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "card_4"
  }, [_c('h1', [_vm._v("受益用户")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_vm._l((_vm.aCard), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))])])]
  })], 2)], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("客户成功案例")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', [_vm._v("针对各行业业务特性，打造个性化行业解决方案，为客户提供一站式的产品与服务。")]), _vm._v(" "), _c('p', [_vm._v("让客户可以轻松实现物联网产品的开发和管理，让产品互联互通。")])])
}]}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_3"
  }, [_c('el-row', _vm._l((_vm.cardList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 3
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      },
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_2"
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": "1"
    },
    on: {
      "select": _vm.fnSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("私有云")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("智能设备")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("智能家居")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("农业灌溉")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v("工业采集")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "title",
    style: ({
      backgroundImage: 'url(' + _vm.content.pic + ')'
    })
  }, [_c('p', [_vm._v(_vm._s(_vm.content.title_sub))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.content.sub_des))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.fnToRouter(_vm.content.btn.url)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.btn.name))]), _vm._v(" "), _c('p', [_vm._v("应用产品")]), _vm._v(" "), _c('p', _vm._l((_vm.content.product), function(item, i) {
    return _c('span', {
      key: i,
      on: {
        "click": function($event) {
          _vm.fnToRouter(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.content.content), function(item, i) {
    return [_c('h3', [_vm._v(_vm._s(item.h))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.p))])]
  })], 2)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_1"
  }, [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, _vm._l((_vm.cardList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 6
      }
    }, [_c('el-card', [_c('div', {
      staticClass: "card",
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.desc))])])])])], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solution"
  }, [_c('div', {
    staticClass: "head",
    style: ({
      backgroundImage: 'url(' + _vm.img.headBg + ')'
    })
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("同品牌公司一样，享有最专业的私有云解决方案")]), _vm._v(" "), _c('p', [_vm._v("账号与权限管理是身份认证和访问权限控制的服务；适用于同一组织下多成员共同管理云计算资源及财务信息的场景；可授予不同成员于不同的资源操作权限。利于企业规划管理及成员权限")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("开启私有云")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabs",
    attrs: {
      "id": "tabs"
    }
  }, [_c('el-tabs', {
    class: {
      fixed: _vm.isFixed
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab_active),
      callback: function($$v) {
        _vm.tab_active = $$v
      },
      expression: "tab_active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "2_1",
      "label": "热门方案"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "2_2",
      "label": "行内方案"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "2_3",
      "label": "受益客户"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('tab_1')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('div', [_vm._v("我们以用户的需求主导产品研发，提供丰富、高性能、稳定的产品和服务")]), _vm._v(" "), _c('tab_2')], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('tab_3')], 1)])], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "tab1"
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("热门解决方案")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "tab2"
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("行内解决方案")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "tab3"
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("受益客户")])
}]}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "index"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-tip"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.fnToWebPage('https://qlinkcc.taobao.com/?qq-pf-to=pcqq.c2c')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-taobao"
  }), _vm._v("酷联商城")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-houtai"
  }), _vm._v("控制台")])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t开启物联网时代，请\n\t\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.fnToRouter('/404')
      }
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header-menu"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": _vm.img.logo
    }
  }), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.fnMenu
    },
    model: {
      value: (_vm.sMenuSelected),
      callback: function($$v) {
        _vm.sMenuSelected = $$v
      },
      expression: "sMenuSelected"
    }
  }, [_vm._l((_vm.$store.state.aIndexMenu), function(item) {
    return [_c('el-tab-pane', {
      attrs: {
        "label": item.name,
        "name": item.path
      }
    })]
  })], 2)], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.mapStyle),
    attrs: {
      "id": "allmap"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('img', {
    attrs: {
      "src": _vm.bgNav
    }
  }), _vm._v(" "), _c('el-menu', {
    attrs: {
      "unique-opened": true,
      "router": "",
      "default-active": _vm.defaultSelect
    }
  }, [_vm._l((_vm.menu), function(item, key) {
    return [(item.child) ? [_c('el-submenu', {
      attrs: {
        "index": key
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-menu-item-group', [_vm._l((item.child), function(i, k) {
      return [_c('el-menu-item', {
        attrs: {
          "index": k
        }
      }, [(i.icon) ? _c('i', {
        class: i.icon
      }) : _vm._e(), _vm._v(_vm._s(i.name))])]
    })], 2)], 2)] : [_c('el-menu-item', {
      attrs: {
        "index": key
      }
    }, [_vm._v(_vm._s(item.name))])]]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "list_group"
  }, [_vm._l((_vm.$store.state.aIndexMenu), function(ul) {
    return _c('ul', [(ul.sub) ? _c('label', {
      on: {
        "click": function($event) {
          _vm.fnToRouter(ul.path)
        }
      }
    }, [_vm._v(_vm._s(ul.name))]) : _vm._e(), _vm._v(" "), _vm._l((ul.sub), function(i) {
      return (ul.sub) ? _c('li', {
        on: {
          "click": function($event) {
            _vm.fnToRouter(i.path)
          }
        }
      }, [_vm._v(_vm._s(i.name))]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("联系我们")]), _vm._v(" "), _vm._l((_vm.about), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.toWan(item.url)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: item.icon
    })])
  })], 2)], 2), _vm._v(" "), _c('footer', [_c('div', [_vm._v("2016版权")]), _vm._v(" "), _c('div', [_vm._v("厦门酷联客电子科技有限公司")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(727)
    },
    on: {
      "click": _vm.toTop
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page404"
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h3', {}, [_vm._v("QLINK酷联客官网")]), _vm._v(" "), _c('small', [_vm._v("全新改版升级中···")]), _vm._v(" "), _c('p', [_vm._v("敬请期待！")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.fnToRouter('/')
      }
    }
  }, [_vm._v("返回主页")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回上一页")]), _vm._v(" "), _c('div', [_vm._v("资讯热线0592-8222272 / 5638000")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[358]);


// WEBPACK FOOTER //
// static/js/app.a59ea58f2d56c45a8da2.js